var vt = Object.defineProperty;
var ht = (t, e, l) => e in t ? vt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: l }) : t[e] = l;
var M = (t, e, l) => ht(t, typeof e != "symbol" ? e + "" : e, l);
import { defineComponent as I, computed as v, ref as $, onMounted as Le, createElementBlock as k, openBlock as d, normalizeStyle as Q, normalizeClass as D, createVNode as O, Transition as Se, withCtx as V, createBlock as _, resolveDynamicComponent as ce, defineAsyncComponent as gt, useSlots as ot, Fragment as J, renderList as te, createElementVNode as R, renderSlot as A, unref as g, nextTick as _e, createTextVNode as q, toDisplayString as X, createCommentVNode as S, mergeProps as j, mergeModels as oe, useModel as le, watch as G, withModifiers as bt, useTemplateRef as ne, watchEffect as He, inject as yt, provide as _t, Teleport as ze, normalizeProps as ie, withDirectives as De, vModelDynamic as kt, TransitionGroup as we, guardReactiveProps as lt, onBeforeUnmount as st, markRaw as St, reactive as wt, vModelText as je, useCssVars as $t, onUnmounted as Bt } from "vue";
import { useBreakpoints as Ct, useThrottleFn as Lt, useEventListener as Xe, useDebounceFn as Ve, useMounted as Vt, useElementSize as it, useElementBounding as Rt, useWindowSize as Mt, useMouseInElement as Te, onClickOutside as Pt, useEventBus as qe, useScroll as It } from "@vueuse/core";
import { z as Dt, v as Ue, c as Tt } from "./vendor-BZ-uveZL.js";
import ke from "dayjs";
import { useRoute as Ot } from "vue-router";
var at = /* @__PURE__ */ ((t) => (t.none = "none", t.rotation = "rotation", t))(at || {}), Wt = /* @__PURE__ */ ((t) => (t.primary = "primary", t.secondary = "secondary", t.tertiary = "tertiary", t.disabled = "disabled", t["inverse-primary"] = "inverse-primary", t["inverse-secondary"] = "inverse-secondary", t["inverse-disabled"] = "inverse-disabled", t.accented = "accented", t.flashsale = "flashsale", t.info = "info", t.positive = "positive", t.caution = "caution", t.negative = "negative", t["icon-tertiary-outlined"] = "icon-tertiary-outlined", t.current = "current", t))(Wt || {});
const xt = /* @__PURE__ */ I({
  __name: "MMIcon",
  props: {
    name: {},
    width: {},
    height: {},
    animation: { default: at.none },
    fill: { default: "currentColor" },
    angle: {},
    color: {}
  },
  setup(t) {
    const e = t, l = v(() => ({
      transform: e.angle ? `rotate(${e.angle}deg)` : void 0,
      minHeight: e.height ? `${e.height}px` : void 0,
      minWidth: e.width ? `${e.width}px` : void 0
    })), s = v(() => ({
      width: `${e.width}px`,
      height: `${e.height}px`
    })), r = $(!0), n = /* @__PURE__ */ Object.assign({ "./svg/_storeIcon.svg": () => import("./icons-gtB1tx5-.js").then((o) => o._), "./svg/application-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.a), "./svg/cart.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.c), "./svg/check-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.b), "./svg/check-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.d), "./svg/chevron-bold.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.e), "./svg/chevron-left.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.f), "./svg/chevron-multicolor.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.g), "./svg/chevron.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.h), "./svg/circular-loader-dark.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.i), "./svg/circular-loader.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.j), "./svg/close.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.k), "./svg/delivery.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.l), "./svg/dismiss-circle-multicolor.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.m), "./svg/dismiss-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.n), "./svg/edit-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.o), "./svg/empty.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.p), "./svg/error-circle-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.q), "./svg/error.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.r), "./svg/filter-fill.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.s), "./svg/flame-red.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.t), "./svg/geo-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.u), "./svg/heart.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.v), "./svg/help-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.w), "./svg/help-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.x), "./svg/home-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.y), "./svg/home-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.z), "./svg/location-pin.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.A), "./svg/magnit-id-logo.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.B), "./svg/magnit-market-logo.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.C), "./svg/mail-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.D), "./svg/main-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.E), "./svg/map-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.F), "./svg/minus.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.G), "./svg/plus.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.H), "./svg/qr-mobile-app.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.I), "./svg/remove-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.J), "./svg/search-categories-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.K), "./svg/search.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.L), "./svg/secure.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.M), "./svg/settings-outlined.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.N), "./svg/shopping-catalog.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.O), "./svg/social-phone.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.P), "./svg/social-telegram.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.Q), "./svg/social-vk.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.R), "./svg/star-filled.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.S), "./svg/star.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.T), "./svg/stars.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.U), "./svg/tail.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.V), "./svg/timer-purple.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.W), "./svg/trash.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.X), "./svg/user.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.Y), "./svg/watch.svg": () => import("./icons-gtB1tx5-.js").then((o) => o.Z) });
    function a(o) {
      const m = `./svg/${o}.svg`, u = n[m];
      return u ? gt(u) : (console.warn(`Icon ${o} not found`), null);
    }
    const i = v(() => a(e.name));
    Le(() => {
      setTimeout(() => {
        r.value = !1;
      }, 200);
    });
    const c = v(() => e.color ? `color_${e.color}` : "");
    return (o, m) => (d(), k("div", {
      class: D(["mm-icon-wrapper", `icon-${o.name}`, c.value]),
      style: Q(l.value)
    }, [
      O(Se, {
        name: r.value ? "" : "icon-change"
      }, {
        default: V(() => [
          (d(), _(ce(i.value), {
            class: D(["mm-icon", `animation-${e.animation}`]),
            key: e.name,
            style: Q(s.value),
            fill: o.fill
          }, null, 8, ["class", "style", "fill"]))
        ]),
        _: 1
      }, 8, ["name"])
    ], 6));
  }
}), T = (t, e) => {
  const l = t.__vccOpts || t;
  for (const [s, r] of e)
    l[s] = r;
  return l;
}, N = /* @__PURE__ */ T(xt, [["__scopeId", "data-v-7830eb04"]]);
var At = /* @__PURE__ */ ((t) => (t._storeIcon = "_storeIcon", t["application-outlined"] = "application-outlined", t.cart = "cart", t["check-filled"] = "check-filled", t["check-outlined"] = "check-outlined", t["chevron-bold"] = "chevron-bold", t["chevron-left"] = "chevron-left", t["chevron-multicolor"] = "chevron-multicolor", t.chevron = "chevron", t["circular-loader-dark"] = "circular-loader-dark", t["circular-loader"] = "circular-loader", t.close = "close", t.delivery = "delivery", t["dismiss-circle-multicolor"] = "dismiss-circle-multicolor", t["dismiss-filled"] = "dismiss-filled", t["edit-outlined"] = "edit-outlined", t.empty = "empty", t["error-circle-filled"] = "error-circle-filled", t.error = "error", t["filter-fill"] = "filter-fill", t["flame-red"] = "flame-red", t["geo-filled"] = "geo-filled", t.heart = "heart", t["help-filled"] = "help-filled", t["help-outlined"] = "help-outlined", t["home-filled"] = "home-filled", t["home-outlined"] = "home-outlined", t["location-pin"] = "location-pin", t["magnit-id-logo"] = "magnit-id-logo", t["magnit-market-logo"] = "magnit-market-logo", t["mail-outlined"] = "mail-outlined", t["main-outlined"] = "main-outlined", t["map-outlined"] = "map-outlined", t.minus = "minus", t.plus = "plus", t["qr-mobile-app"] = "qr-mobile-app", t["remove-filled"] = "remove-filled", t["search-categories-outlined"] = "search-categories-outlined", t.search = "search", t.secure = "secure", t["settings-outlined"] = "settings-outlined", t["shopping-catalog"] = "shopping-catalog", t["social-phone"] = "social-phone", t["social-telegram"] = "social-telegram", t["social-vk"] = "social-vk", t["star-filled"] = "star-filled", t.star = "star", t.stars = "stars", t.tail = "tail", t["timer-purple"] = "timer-purple", t.trash = "trash", t.user = "user", t.watch = "watch", t))(At || {});
const Ht = ["onClick", "onMouseenter"], zt = { class: "mm-accordion-item__content" }, Ut = /* @__PURE__ */ I({
  __name: "MMAccordion",
  props: {
    singleOpen: { type: Boolean },
    compact: { type: Boolean }
  },
  setup(t) {
    const e = t, l = $([]), s = $([]), r = ot(), n = v(() => {
      let u = 0;
      for (; `header-${u}` in r || `content-${u}` in r; )
        u++;
      return u;
    }), a = async (u) => {
      e.singleOpen ? l.value.includes(u) ? l.value = [] : l.value = [u] : l.value.includes(u) ? l.value = l.value.filter((y) => y !== u) : l.value.push(u), await _e(), i();
    }, i = () => {
      s.value.forEach((u, y) => {
        u && (l.value.includes(y) ? u.style.maxHeight = `${u.scrollHeight}px` : u.style.maxHeight = "0px");
      });
    };
    i();
    const c = $([]);
    function o(u) {
      const y = c.value[u - 2];
      y && y.classList.add("hovered-prev");
    }
    function m() {
      c.value.forEach((u) => {
        u && u.classList.remove("hovered-prev");
      });
    }
    return (u, y) => (d(), k("div", {
      class: D(["mm-accordion", [{ compact: u.compact }]])
    }, [
      (d(!0), k(J, null, te(n.value, (b) => (d(), k("div", {
        key: b,
        class: D(["mm-accordion-item", { open: l.value.includes(b - 1) }]),
        ref_for: !0,
        ref_key: "itemsRef",
        ref: c
      }, [
        R("div", {
          class: "mm-accordion-item__header",
          onClick: (h) => a(b - 1),
          onMouseenter: (h) => o(b),
          onMouseleave: m
        }, [
          A(u.$slots, `header-${b - 1}`, {}, void 0, !0),
          O(g(N), {
            name: "chevron",
            class: "mm-accordion-item__header-chevron",
            height: 20,
            width: 20,
            angle: l.value.includes(b - 1) ? -180 : 0
          }, null, 8, ["angle"])
        ], 40, Ht),
        R("div", {
          ref_for: !0,
          ref_key: "contentRefs",
          ref: s,
          class: "mm-accordion-item__content-wrapper"
        }, [
          R("div", zt, [
            A(u.$slots, `content-${b - 1}`, {}, void 0, !0)
          ])
        ], 512)
      ], 2))), 128))
    ], 2));
  }
}), is = /* @__PURE__ */ T(Ut, [["__scopeId", "data-v-319185cf"]]);
var nt = /* @__PURE__ */ ((t) => (t.primary = "primary", t.secondary = "secondary", t.tertiary = "tertiary", t.disabled = "disabled", t["inverse-primary"] = "inverse-primary", t["inverse-secondary"] = "inverse-secondary", t["inverse-disabled"] = "inverse-disabled", t.accented = "accented", t.flashsale = "flashsale", t.info = "info", t.positive = "positive", t.caution = "caution", t.negative = "negative", t.current = "current", t.transparent = "transparent", t))(nt || {}), rt = /* @__PURE__ */ ((t) => (t["Display M/Bold"] = "Display M/Bold", t["Display S/Bold"] = "Display S/Bold", t["Headline L/Medium"] = "Headline L/Medium", t["Headline L/Semibold"] = "Headline L/Semibold", t["Headline L/Bold"] = "Headline L/Bold", t["Headline M/Medium"] = "Headline M/Medium", t["Headline M/Semibold"] = "Headline M/Semibold", t["Headline M/Bold"] = "Headline M/Bold", t["Headline S/Medium"] = "Headline S/Medium", t["Headline S/Semibold"] = "Headline S/Semibold", t["Headline S/Bold"] = "Headline S/Bold", t["Title L/Medium"] = "Title L/Medium", t["Title L/Medium Long"] = "Title L/Medium Long", t["Title L/Semibold"] = "Title L/Semibold", t["Title L/Semibold Long"] = "Title L/Semibold Long", t["Title L/Bold"] = "Title L/Bold", t["Title L/Bold Long"] = "Title L/Bold Long", t["Title M/Medium"] = "Title M/Medium", t["Title M/Medium Long"] = "Title M/Medium Long", t["Title M/Semibold"] = "Title M/Semibold", t["Title M/Semibold Long"] = "Title M/Semibold Long", t["Title M/Bold"] = "Title M/Bold", t["Title M/Bold Long"] = "Title M/Bold Long", t["Title S/Medium"] = "Title S/Medium", t["Title S/Medium Long"] = "Title S/Medium Long", t["Title S/Semibold"] = "Title S/Semibold", t["Title S/Semibold Long"] = "Title S/Semibold Long", t["Title S/Bold"] = "Title S/Bold", t["Title S/Bold Long"] = "Title S/Bold Long", t["Body L/Regular"] = "Body L/Regular", t["Body L/Regular Long"] = "Body L/Regular Long", t["Body L/Medium"] = "Body L/Medium", t["Body L/Medium Long"] = "Body L/Medium Long", t["Body L/Semibold"] = "Body L/Semibold", t["Body L/Semibold Long"] = "Body L/Semibold Long", t["Body L/Bold"] = "Body L/Bold", t["Body L/Bold Long"] = "Body L/Bold Long", t["Body M/Regular"] = "Body M/Regular", t["Body M/Regular Long"] = "Body M/Regular Long", t["Body M/Medium"] = "Body M/Medium", t["Body M/Medium Long"] = "Body M/Medium Long", t["Body M/Semibold"] = "Body M/Semibold", t["Body M/Semibold Long"] = "Body M/Semibold Long", t["Body M/Bold"] = "Body M/Bold", t["Body M/Bold Long"] = "Body M/Bold Long", t["Body S/Regular"] = "Body S/Regular", t["Body S/Regular Long"] = "Body S/Regular Long", t["Body S/Medium"] = "Body S/Medium", t["Body S/Medium Long"] = "Body S/Medium Long", t["Body S/Semibold"] = "Body S/Semibold", t["Body S/Semibold Long"] = "Body S/Semibold Long", t["Body S/Bold"] = "Body S/Bold", t["Body S/Bold Long"] = "Body S/Bold Long", t["Caption L/Medium"] = "Caption L/Medium", t["Caption L/Regular"] = "Caption L/Regular", t["Caption M/Regular"] = "Caption M/Regular", t["Caption M/Medium"] = "Caption M/Medium", t["Caption S/Regular"] = "Caption S/Regular", t["Caption S/Medium"] = "Caption S/Medium", t))(rt || {});
class Yt {
  static DEFAULT_BREAKPOINTS() {
    return {
      Mobile: [0, 640],
      Tablet: [640, 960],
      Laptop: [960, 1280],
      Desktop: [1280, 1448],
      DesktopMax: [1448]
    };
  }
}
const re = class re {
  constructor() {
    M(this, "normalizedBreakpoints", {});
    this.setBreakpoints(Yt.DEFAULT_BREAKPOINTS());
  }
  static getInstance() {
    return re._instance || (re._instance = new re()), re._instance;
  }
  setBreakpoints(e) {
    this.normalizedBreakpoints = {}, Object.keys(e).forEach((l) => {
      this.normalizedBreakpoints[l] = e[l][0];
    });
  }
  getNormalizedBreakpointsRef() {
    return this.normalizedBreakpoints;
  }
};
M(re, "_instance");
let Oe = re;
const Ge = Oe.getInstance();
function ut() {
  const { smaller: t, greaterOrEqual: e } = Ct(
    Ge.getNormalizedBreakpointsRef()
  ), l = v(() => {
    var p;
    return (p = t("Tablet")) == null ? void 0 : p.value;
  }), s = v(
    () => {
      var p, f;
      return ((p = t("Laptop")) == null ? void 0 : p.value) && ((f = e("Tablet")) == null ? void 0 : f.value);
    }
  ), r = v(
    () => {
      var p, f;
      return ((p = t("Desktop")) == null ? void 0 : p.value) && ((f = e("Laptop")) == null ? void 0 : f.value);
    }
  ), n = v(
    () => {
      var p, f;
      return ((p = t("DesktopMax")) == null ? void 0 : p.value) && ((f = e("Desktop")) == null ? void 0 : f.value);
    }
  ), a = v(() => {
    var p;
    return (p = e("DesktopMax")) == null ? void 0 : p.value;
  }), i = v(() => l.value || s.value), c = v(() => {
    var p;
    return (p = e("Mobile")) == null ? void 0 : p.value;
  }), o = v(() => {
    var p;
    return (p = e("Tablet")) == null ? void 0 : p.value;
  }), m = v(() => {
    var p;
    return (p = e("Laptop")) == null ? void 0 : p.value;
  }), u = v(() => {
    var p;
    return (p = e("Desktop")) == null ? void 0 : p.value;
  }), y = v(() => {
    var p;
    return (p = t("Tablet")) == null ? void 0 : p.value;
  }), b = v(() => {
    var p;
    return (p = t("Laptop")) == null ? void 0 : p.value;
  }), h = v(() => {
    var p;
    return (p = t("Desktop")) == null ? void 0 : p.value;
  }), B = v(() => {
    var p;
    return (p = t("DesktopMax")) == null ? void 0 : p.value;
  }), C = v(() => l.value ? "Mobile" : s.value ? "Tablet" : r.value ? "Laptop" : n.value ? "Desktop" : "DesktopMax"), P = v(() => Ge.getNormalizedBreakpointsRef());
  return {
    isMobile: l,
    isTablet: s,
    isLaptop: r,
    isDesktop: n,
    isDesktopMax: a,
    isMobileOrTablet: i,
    isMobileAndUp: c,
    isTabletAndUp: o,
    isLaptopAndUp: m,
    isDesktopAndUp: u,
    isMobileAndDown: y,
    isTabletAndDown: b,
    isLaptopAndDown: h,
    isDesktopAndDown: B,
    screen: C,
    breakpoints: P
  };
}
const Ne = "mm-text", jt = /* @__PURE__ */ I({
  __name: "MMText",
  props: {
    font: { default: rt["Body L/Regular"] },
    fontMobileOrTablet: {},
    fontMobile: {},
    fontTablet: {},
    fontLaptop: {},
    fontDesktop: {},
    fontDesktopMax: {},
    tag: { default: "div" },
    color: { default: nt.primary },
    label: {}
  },
  setup(t) {
    const e = t, { isMobile: l, isTablet: s, isLaptop: r, isDesktop: n, isDesktopMax: a, isMobileOrTablet: i } = ut(), c = v(() => e.fontMobile && l.value ? e.fontMobile : e.fontTablet && s.value ? e.fontTablet : e.fontMobileOrTablet && i.value ? e.fontMobileOrTablet : e.fontLaptop && r.value ? e.fontLaptop : e.fontDesktop && n.value ? e.fontDesktop : e.fontDesktopMax && a.value ? e.fontDesktopMax : e.font), o = v(() => {
      const m = c.value.toLowerCase().replace(/[\s/]+/g, "-").replace(/-+/g, "-");
      return `${Ne}_${m}`;
    });
    return (m, u) => (d(), _(ce(m.tag), {
      class: D(["mm-text", o.value, `${Ne}_${m.color}`])
    }, {
      default: V(() => [
        A(m.$slots, "default", {}, () => [
          q(X(m.label), 1)
        ], !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), z = /* @__PURE__ */ T(jt, [["__scopeId", "data-v-531142b2"]]), Xt = /* @__PURE__ */ I({
  __name: "MMBadge",
  props: {
    label: {},
    font: { default: "Caption M/Medium" },
    color: {},
    backgroundColor: {}
  },
  setup(t) {
    const e = t, l = v(() => ({
      color: e.color,
      backgroundColor: e.backgroundColor
    }));
    return (s, r) => (d(), k("div", {
      class: "mm-badge",
      style: Q(l.value)
    }, [
      s.label ? (d(), _(g(z), {
        key: 1,
        font: s.font
      }, {
        default: V(() => [
          q(X(s.label), 1)
        ]),
        _: 1
      }, 8, ["font"])) : A(s.$slots, "default", { key: 0 }, void 0, !0)
    ], 4));
  }
}), as = /* @__PURE__ */ T(Xt, [["__scopeId", "data-v-49e542b3"]]);
var ae = /* @__PURE__ */ ((t) => (t.XS28 = "XS28", t.XS32 = "XS32", t.S36 = "S36", t.M40 = "M40", t.L48 = "L48", t.XL56 = "XL56", t))(ae || {}), se = /* @__PURE__ */ ((t) => (t.PrimaryAccented = "PrimaryAccented", t.PrimaryNeutral = "PrimaryNeutral", t.PrimaryInverted = "PrimaryInverted", t.SecondaryAccented = "SecondaryAccented", t.SecondaryNeutral = "SecondaryNeutral", t.SecondaryInverted = "SecondaryInverted", t.TertiaryOutlined = "TertiaryOutlined", t.TertiaryGhost = "TertiaryGhost", t.Text = "Text", t.TextPrimary = "TextPrimary", t))(se || {}), dt = /* @__PURE__ */ ((t) => (t.left = "left", t.center = "center", t.right = "right", t))(dt || {});
const qt = ["disabled"], Gt = /* @__PURE__ */ I({
  __name: "MMButton",
  props: {
    size: { default: ae.M40 },
    design: { default: se.PrimaryAccented },
    label: {},
    disabled: { type: Boolean },
    loading: { type: Boolean },
    prefixIcon: {},
    postfixIcon: {},
    round: { type: Boolean },
    rounded: { type: Boolean },
    nowrap: { type: Boolean },
    noPadding: { type: Boolean },
    fullWidth: { type: Boolean },
    textProps: {},
    align: { default: dt.center },
    hint: {}
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const l = e, s = t, r = v(() => {
      switch (s.size) {
        case ae.XS28:
          return "Body S/Medium";
        case ae.XS32:
          return "Body M/Medium";
        case ae.S36:
        case ae.M40:
          return "Body M/Medium";
        case ae.L48:
          return "Body L/Medium";
        case ae.XL56:
          return "Body L/Semibold";
        default:
          return "Body M/Medium";
      }
    }), n = v(() => {
      var u, y;
      return {
        font: ((u = s.textProps) == null ? void 0 : u.font) || r.value,
        color: ((y = s.textProps) == null ? void 0 : y.color) || "primary",
        ...s.textProps
      };
    }), a = v(() => {
      let u;
      switch (s.design) {
        case se.PrimaryInverted:
        case se.SecondaryAccented:
        case se.SecondaryNeutral:
        case se.SecondaryInverted:
        case se.TertiaryOutlined:
        case se.TertiaryGhost:
        case se.Text:
          u = "circular-loader-dark";
          break;
        default:
          u = "circular-loader";
      }
      return {
        name: u
      };
    }), i = v(() => s.disabled || s.loading), c = ot(), o = v(() => !!c.default);
    function m(u) {
      l("click", u);
    }
    return (u, y) => {
      var b, h;
      return d(), k("button", {
        class: D(["mm-button", [
          `size-${u.size}`,
          `design-${u.design}`,
          `align-${u.align}`,
          { loading: u.loading, rounded: u.rounded, round: u.round, nowrap: u.nowrap, noPadding: u.noPadding, fullWidth: u.fullWidth }
        ]]),
        disabled: i.value,
        onClick: m
      }, [
        u.loading ? (d(), _(N, j({ key: 0 }, a.value, {
          animation: "rotation",
          class: "mm-button_loader"
        }), null, 16)) : S("", !0),
        (b = u.prefixIcon) != null && b.name ? (d(), _(N, j({ key: 1 }, u.prefixIcon, { class: "mm-button_prefix-icon" }), null, 16)) : S("", !0),
        o.value || u.label ? (d(), _(g(z), j({
          key: 2,
          class: "mm-button_label"
        }, n.value), {
          default: V(() => [
            o.value ? A(u.$slots, "default", { key: 1 }, void 0, !0) : (d(), k(J, { key: 0 }, [
              q(X(u.label), 1)
            ], 64))
          ]),
          _: 3
        }, 16)) : S("", !0),
        (h = u.postfixIcon) != null && h.name ? (d(), _(N, j({ key: 3 }, u.postfixIcon, { class: "mm-button_postfix-icon" }), null, 16)) : S("", !0)
      ], 10, qt);
    };
  }
}), ee = /* @__PURE__ */ T(Gt, [["__scopeId", "data-v-3374a98e"]]), Nt = {}, Kt = { class: "mm-card" };
function Jt(t, e) {
  return d(), k("div", Kt, [
    A(t.$slots, "default", {}, void 0, !0)
  ]);
}
const ns = /* @__PURE__ */ T(Nt, [["render", Jt], ["__scopeId", "data-v-18c7d9fe"]]), Qt = /* @__PURE__ */ I({
  __name: "MMField",
  props: {
    disabled: { type: Boolean },
    label: { type: Boolean, default: !0 },
    error: { default: null }
  },
  setup(t) {
    return (e, l) => (d(), _(ce(e.label ? "label" : "div"), {
      class: D(["mm-field", { disabled: e.disabled }])
    }, {
      default: V(() => [
        A(e.$slots, "default", {}, void 0, !0),
        O(Se, { name: "mm-field-error" }, {
          default: V(() => [
            e.error ? (d(), _(g(z), {
              key: 0,
              font: "Body S/Regular",
              class: "mm-field__error",
              color: "negative"
            }, {
              default: V(() => [
                q(X(e.error), 1)
              ]),
              _: 1
            })) : S("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Re = /* @__PURE__ */ T(Qt, [["__scopeId", "data-v-05afd8da"]]);
var ye = /* @__PURE__ */ ((t) => (t.S16 = "S16", t.M24 = "M24", t.L32 = "L32", t))(ye || {});
const Zt = ["checked", "indeterminate", "disabled"], Ft = ["src", "alt"], Et = /* @__PURE__ */ I({
  __name: "MMCheckbox",
  props: /* @__PURE__ */ oe({
    disabled: { type: Boolean },
    label: {},
    size: { default: ye.S16 },
    font: { default: "Body M/Regular" },
    background: {},
    backgroundAlt: {}
  }, {
    modelValue: { type: [Boolean, null] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, l = le(t, "modelValue"), s = (o) => {
      l.value = o.target.checked;
    }, r = v(() => l.value === null), n = v(() => {
      var o;
      return ((o = l.value) == null ? void 0 : o.toString()) ?? "";
    }), a = v(() => l.value === !1 ? "empty" : l.value === !0 ? "check-filled" : "remove-filled"), i = v(() => {
      switch (e.size) {
        case ye.S16:
          return 7;
        case ye.M24:
          return 10;
        case ye.L32:
          return 13;
        default:
          return 7;
      }
    }), c = v(() => ({
      "mm-checkbox": !0,
      [`size-${e.size}`]: !0,
      checked: l.value === !0,
      mixed: l.value === null,
      disabled: e.disabled,
      custom: !!e.background
    }));
    return (o, m) => (d(), _(g(Re), {
      modelValue: n.value,
      disabled: o.disabled
    }, {
      default: V(() => [
        R("div", {
          class: D(c.value)
        }, [
          R("input", {
            type: "checkbox",
            checked: l.value === !0,
            indeterminate: r.value,
            disabled: o.disabled,
            onChange: s
          }, null, 40, Zt),
          o.background ? (d(), k("img", {
            key: 0,
            src: o.background,
            alt: o.backgroundAlt,
            class: "mm-checkbox__background"
          }, null, 8, Ft)) : S("", !0),
          o.background ? S("", !0) : (d(), _(g(N), {
            key: 1,
            name: a.value,
            width: i.value
          }, null, 8, ["name", "width"])),
          O(g(z), {
            font: o.font,
            color: o.disabled ? "disabled" : "primary"
          }, {
            default: V(() => [
              A(o.$slots, "default", {}, () => [
                q(X(o.label), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["font", "color"])
        ], 2)
      ]),
      _: 3
    }, 8, ["modelValue", "disabled"]));
  }
}), rs = /* @__PURE__ */ T(Et, [["__scopeId", "data-v-cfd29665"]]), eo = ["disabled", "onInput", "onFocus"], to = /* @__PURE__ */ I({
  __name: "MMCodeField",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    error: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const l = t, s = e, r = $([]), n = $([]), a = v(() => r.value.join(""));
    G(a, (b) => {
      s("update:modelValue", b);
    }), G(
      () => l.modelValue,
      (b) => {
        b !== r.value.join("") && (r.value = (b == null ? void 0 : b.split("")) || [], n.value.forEach((h, B) => {
          b != null && b[B] && b[B] !== h.value ? h.value = b[B] : h.value = "";
        }));
      }
    );
    const i = (b, h) => {
      const B = b.target, C = B.value;
      if (!/^\d*$/.test(C)) {
        B.value = "";
        return;
      }
      if (!C && r.value[h]) {
        C === "" && (r.value[h] = "");
        const p = n.value[h - 2];
        p && p.focus();
        return;
      }
      r.value[h] = C;
      const P = n.value[h];
      P && P.focus();
    }, c = (b) => {
      var B;
      b.preventDefault();
      const h = (B = b.clipboardData) == null ? void 0 : B.getData("text/plain");
      if (h) {
        if (!/^\d{5}$/.test(h))
          return;
        const C = h.split("");
        r.value = C.map(String), n.value.forEach((P, p) => {
          P.value = C[p];
        });
      }
    }, o = $(null), m = (b) => o.value === b, u = (b) => {
      o.value = b;
    }, y = () => {
      o.value = null;
    };
    return (b, h) => (d(), _(g(Re), {
      class: "mm-code-field",
      modelValue: a.value,
      label: !1,
      error: b.error
    }, {
      default: V(() => [
        R("div", {
          class: D(["mm-code-field__wrapper", { error: !!b.error }])
        }, [
          (d(), k(J, null, te(5, (B) => R("div", {
            class: D(["mm-code-field__input-wrapper", { populated: !!r.value[B - 1], focused: m(B) }]),
            key: B
          }, [
            R("input", {
              maxlength: "1",
              ref_for: !0,
              ref_key: "inputsRef",
              ref: n,
              placeholder: "•",
              disabled: b.disabled,
              onInput: (C) => i(C, B),
              onPaste: c,
              onClick: h[0] || (h[0] = bt(() => {
              }, ["stop"])),
              onFocus: (C) => u(B),
              onBlur: y
            }, null, 40, eo)
          ], 2)), 64))
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "error"]));
  }
}), us = /* @__PURE__ */ T(to, [["__scopeId", "data-v-e6f80f57"]]), oo = {}, lo = { class: "mm-container" };
function so(t, e) {
  return d(), k("div", lo, [
    A(t.$slots, "default", {}, void 0, !0)
  ]);
}
const ds = /* @__PURE__ */ T(oo, [["render", so], ["__scopeId", "data-v-80241a4a"]]), io = ["src", "alt"], ao = /* @__PURE__ */ I({
  __name: "MMImage",
  props: {
    src: {},
    low: {},
    alt: {},
    hasLoader: { type: Boolean, default: !0 },
    pause: { type: Boolean }
  },
  setup(t) {
    const e = t, l = $(e.low || e.src), s = $(!1);
    function r() {
      s.value = !0, !(e.pause || !e.src) && l.value === e.low && (l.value = e.src);
    }
    const n = $(!1);
    function a() {
      n.value = !0;
    }
    return G(
      () => e.pause,
      (i) => {
        !i && s.value && l.value !== e.src && e.src && (l.value = e.src);
      }
    ), G([() => e.src, () => e.low], ([i, c]) => {
      n.value = !1, s.value = !1, l.value = c || i;
    }), (i, c) => (d(), k("div", {
      class: D(["mm-image", { "mm-image--errored": n.value }])
    }, [
      R("img", {
        src: l.value,
        alt: i.alt,
        onLoad: r,
        onError: a
      }, null, 40, io),
      n.value ? (d(), _(g(z), {
        key: 0,
        font: "Caption S/Regular",
        class: "mm-image__alt"
      }, {
        default: V(() => [
          q(X(i.alt), 1)
        ]),
        _: 1
      })) : S("", !0),
      i.hasLoader && !s.value && !n.value ? (d(), _(g(N), {
        key: 1,
        class: "mm-image__loader",
        name: "circular-loader",
        animation: "rotation",
        height: 56,
        width: 56
      })) : S("", !0)
    ], 2));
  }
}), Ye = /* @__PURE__ */ T(ao, [["__scopeId", "data-v-10d377da"]]);
function no() {
  const t = $(/* @__PURE__ */ new Set());
  function e(i, c = {}) {
    const o = c.sensitivity ?? 1e-4, m = c.friction ?? 0.89, u = c.snapDelay ?? 80;
    let y = null, b = 0, h = null;
    function B() {
      if (!i) return;
      b *= m;
      const P = i.track, p = P.details;
      let f = p.position - b;
      f < p.min && (f = p.min), f > p.max && (f = p.max), P.to(f), Math.abs(b) > 0.01 ? y = requestAnimationFrame(B) : (y = null, h && clearTimeout(h), i.options.mode === "free-snap" && (h = window.setTimeout(() => {
        const W = p.rel;
        i.moveToIdx(W, !0), h = null;
      }, u)));
    }
    function C(P) {
      if (Math.abs(P.deltaX) < 0.5) return;
      P.preventDefault(), h && (clearTimeout(h), h = null);
      const p = Math.abs(P.deltaX) > Math.abs(P.deltaY) ? P.deltaX : P.deltaY;
      b -= p * o, y || (y = requestAnimationFrame(B));
    }
    i.on("created", () => {
      i.container.addEventListener("wheel", C, { passive: !1 });
    }), i.on("destroyed", () => {
      i.container.removeEventListener("wheel", C), y && cancelAnimationFrame(y), h && clearTimeout(h);
    });
  }
  function l(i, c = {}, o = !1) {
    if (!o) return;
    const m = i.options.slides, u = c.step ?? (typeof m.perView == "number" ? m.perView : 1), y = i.next.bind(i), b = i.prev.bind(i);
    function h() {
      return u;
    }
    i.next = () => {
      const B = i.track.details, C = h();
      if (i.options.loop)
        i.moveToIdx((B.rel + C) % B.slides.length);
      else {
        const P = Math.min(B.slides.length - C, B.rel + C);
        i.moveToIdx(P);
      }
    }, i.prev = () => {
      const B = i.track.details, C = h();
      if (i.options.loop) {
        let P = B.rel - C;
        P < 0 && (P = B.slides.length + P), i.moveToIdx(P % B.slides.length);
      } else {
        const P = Math.max(0, B.rel - C);
        i.moveToIdx(P);
      }
    }, i.on("destroyed", () => {
      i.next = y, i.prev = b;
    });
  }
  const s = (i, c, o) => {
    if (!c) return;
    let m, u = !1;
    function y() {
      clearTimeout(m);
    }
    function b() {
      clearTimeout(m), !u && (m = setTimeout(() => {
        i.next();
      }, o));
    }
    i.on("created", () => {
      Xe(i.container, "mouseover", () => {
        u = !0, y();
      }), Xe(i.container, "mouseout", () => {
        u = !1, b();
      }), b();
    }), i.on("dragStarted", y), i.on("animationEnded", b), i.on("updated", b);
  }, r = (i) => {
    i.on("detailsChanged", () => {
      n(i);
    });
  }, n = Lt(a, 150);
  function a(i) {
    const c = i.track.details.slides;
    c.forEach((o) => {
      o.portion > 0 && (c[o.abs - 1] && t.value.add(o.abs - 1), t.value.add(o.abs), c[o.abs + 1] && t.value.add(o.abs + 1));
    });
  }
  return {
    loadedSlides: t,
    WheelControls: e,
    AutoSwitch: s,
    LoadedSlidesWatcher: r,
    StepNavPlugin: l
  };
}
const ro = { class: "navigation-wrapper mm-slider" }, uo = /* @__PURE__ */ I({
  __name: "MMSlider",
  props: {
    options: { default: () => ({}) },
    controls: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    autoswitch: { type: Boolean },
    autoswitchInterval: { default: 5e3 },
    wheel: { type: Boolean },
    visibleOverflow: { type: Boolean },
    visibleYOverflow: { type: Boolean },
    radius: { default: 12 },
    stepNavigation: { type: Boolean, default: !1 }
  },
  emits: ["scroll", "slide-change"],
  setup(t, { expose: e, emit: l }) {
    const s = t, r = l, n = v(() => {
      var L;
      return (L = s.options) == null ? void 0 : L.vertical;
    }), a = $(0), i = $(0), c = $(!1), o = $(!0), m = Ve((L) => {
      i.value = L;
    }, 150), u = (L) => {
      a.value = L.track.details.rel, m(L.track.details.rel), c.value = L.track.details.maxIdx === a.value, o.value = L.track.details.minIdx === a.value, r("slide-change", L.track.details.rel);
    }, { WheelControls: y, AutoSwitch: b, LoadedSlidesWatcher: h, loadedSlides: B, StepNavPlugin: C } = no(), P = v(() => ({
      slideChanged: u,
      created: (L) => {
        var U, Y;
        (Y = (U = L == null ? void 0 : L.track) == null ? void 0 : U.details) != null && Y.maxIdx || (c.value = !0);
      },
      selector: ".mm-slider__slide",
      slides: {
        spacing: 12
      },
      ...s.options
    })), [p, f] = Dt(
      {
        ...P.value
      },
      [
        (L) => y(L),
        (L) => b(L, s.autoswitch, s.autoswitchInterval),
        (L) => h(L),
        (L) => C(L, {}, s.stepNavigation)
      ]
    );
    function W(L) {
      var E, w, x;
      const U = typeof s.options.slides == "object" && typeof ((E = s.options.slides) == null ? void 0 : E.perView) == "number" ? s.options.slides.perView : 0, Y = ((w = f == null ? void 0 : f.value) == null ? void 0 : w.slides.length) ?? 0;
      L > Y - U && (L = Y - U), (x = f == null ? void 0 : f.value) == null || x.moveToIdx(L);
    }
    function H() {
      var L;
      (L = f == null ? void 0 : f.value) == null || L.update(P.value, 0);
    }
    return e({
      currentSlide: i,
      loadedSlides: B,
      moveTo: W,
      update: H
    }), G(() => s.stepNavigation, () => {
      H();
    }), (L, U) => (d(), k("div", ro, [
      R("div", {
        ref_key: "container",
        ref: p,
        class: D(["keen-slider", {
          "overflow-visible": L.visibleOverflow,
          "overflow-y-visible": L.visibleYOverflow
        }]),
        style: Q({ borderRadius: `${s.radius}px` })
      }, [
        A(L.$slots, "default")
      ], 6),
      L.controls && g(f) ? (d(), k(J, { key: 0 }, [
        R("div", {
          class: D([
            "mm-slider__control-wrapper prev",
            { disabled: o.value, vertical: n.value }
          ])
        }, [
          O(g(ee), {
            onClick: U[0] || (U[0] = (Y) => g(f).prev()),
            design: "SecondaryNeutral",
            class: "mm-slider__control",
            size: "M40",
            "postfix-icon": { name: "chevron", angle: n.value ? 180 : 90 },
            round: "",
            "aria-label": "Предыдущий слайд"
          }, null, 8, ["postfix-icon"])
        ], 2),
        R("div", {
          class: D([
            "mm-slider__control-wrapper next",
            { disabled: c.value, vertical: n.value }
          ])
        }, [
          O(g(ee), {
            onClick: U[1] || (U[1] = (Y) => g(f).next()),
            design: "SecondaryNeutral",
            class: "mm-slider__control",
            size: "M40",
            "postfix-icon": { name: "chevron", angle: n.value ? 0 : -90 },
            round: "",
            "aria-label": "Следующий слайд"
          }, null, 8, ["postfix-icon"])
        ], 2)
      ], 64)) : S("", !0),
      L.shadow && g(f) ? (d(), k(J, { key: 1 }, [
        R("div", {
          class: D([
            "mm-slider__shadow-wrapper",
            "prev",
            { disabled: o.value, vertical: n.value }
          ])
        }, null, 2),
        R("div", {
          class: D([
            "mm-slider__shadow-wrapper",
            "next",
            { disabled: c.value, vertical: n.value }
          ])
        }, null, 2)
      ], 64)) : S("", !0)
    ]));
  }
}), ct = /* @__PURE__ */ T(uo, [["__scopeId", "data-v-e760bfdd"]]), co = { class: "mm-image-slider" }, po = ["onClick"], mo = ["src"], fo = { class: "mm-image-slider__current-slide" }, vo = ["src"], ho = ["src"], go = /* @__PURE__ */ I({
  __name: "MMImageSliderDesktop",
  props: {
    list: {},
    options: {},
    mobile: { type: Boolean }
  },
  setup(t, { expose: e }) {
    const l = $(), s = $(0);
    G(s, (i) => {
      var o;
      n.value = !1;
      const c = i === 0 ? 0 : i - 1;
      (o = l.value) == null || o.moveTo(c);
    });
    const r = (i) => {
      s.value = i;
    }, n = $(!1);
    function a() {
      n.value = !0;
    }
    return e({
      setCurrentSlide: (i) => {
        s.value = i;
      }
    }), (i, c) => {
      var o;
      return d(), k("div", co, [
        O(g(ct), {
          options: i.options,
          wheel: "",
          ref_key: "sliderRef",
          ref: l
        }, {
          default: V(() => [
            (d(!0), k(J, null, te(i.list, (m, u) => (d(), k("div", {
              class: D(["mm-slider__slide", { active: s.value === u }]),
              key: m.src,
              onClick: (y) => r(u)
            }, [
              R("img", {
                src: m.low
              }, null, 8, mo)
            ], 10, po))), 128))
          ]),
          _: 1
        }, 8, ["options"]),
        R("div", fo, [
          (d(!0), k(J, null, te(i.list, (m, u) => (d(), k("img", {
            class: D(["mm-image-slider__current-slide__img low", { active: s.value === u }]),
            src: m.low,
            key: m.src
          }, null, 10, vo))), 128)),
          R("img", {
            src: (o = i.list[s.value]) == null ? void 0 : o.src,
            class: D(["mm-image-slider__current-slide__img high", { active: n.value }]),
            onLoad: a
          }, null, 42, ho)
        ])
      ]);
    };
  }
}), bo = /* @__PURE__ */ T(go, [["__scopeId", "data-v-c8d0877a"]]), yo = { class: "mm-image-slider-wrapper" }, _o = ["data-index", "onClick"], ko = /* @__PURE__ */ I({
  __name: "MMImageSliderMobile",
  props: {
    list: {},
    options: {}
  },
  setup(t, { expose: e }) {
    const l = $(), s = $(/* @__PURE__ */ new Set([0])), r = Ve((o) => {
      s.value.add(+o);
    }, 50), n = (o) => {
      r(o);
    }, a = Vt();
    function i(o) {
      if (!a.value) return !1;
      const m = s.value.has(o), u = s.value.has(o - 1), y = s.value.has(o + 1);
      return m || u || y;
    }
    function c(o) {
      var m;
      (m = l.value) == null || m.moveTo(o);
    }
    return e({
      setCurrentSlide: (o) => {
        var m;
        (m = l.value) == null || m.moveTo(o);
      }
    }), (o, m) => (d(), k("div", yo, [
      O(g(ct), {
        options: o.options,
        controls: !1,
        shadow: !1,
        "visible-overflow": "",
        class: "mm-image-slider",
        ref_key: "sliderRef",
        ref: l,
        onSlideChange: n
      }, {
        default: V(() => [
          (d(!0), k(J, null, te(o.list, (u, y) => (d(), k("div", {
            class: "mm-slider__slide",
            key: u.src,
            ref_for: !0,
            ref: "slides",
            "data-index": y,
            onClick: (b) => c(y)
          }, [
            i(y) ? (d(), _(g(Ye), {
              key: 0,
              src: u.src,
              low: u.low
            }, null, 8, ["src", "low"])) : S("", !0)
          ], 8, _o))), 128))
        ]),
        _: 1
      }, 8, ["options"])
    ]));
  }
}), So = /* @__PURE__ */ T(ko, [["__scopeId", "data-v-e8ee48cc"]]), pt = (t, e) => {
  if (!e) return t;
  const l = { ...t };
  return Object.keys(e).forEach((s) => {
    Ke(t[s]) && Ke(e[s]) ? l[s] = pt(
      t[s],
      e[s]
    ) : l[s] = e[s];
  }), l;
}, Ke = (t) => t && typeof t == "object" && !Array.isArray(t), cs = /* @__PURE__ */ I({
  __name: "MMImageSlider",
  props: {
    list: {},
    sliderOptions: {},
    mobile: { type: Boolean },
    initialSlide: {}
  },
  setup(t, { expose: e }) {
    const l = t, s = v(() => {
      const c = {
        vertical: !l.mobile,
        slides: {
          perView: l.mobile ? "auto" : 4,
          spacing: l.mobile ? 8 : 12
        }
      };
      return pt(
        c,
        l.sliderOptions || {}
      );
    }), r = ne("desktopSlider"), n = ne("mobileSlider"), a = $(l.initialSlide || 0);
    e({
      setCurrentSlide: (c) => {
        var o, m;
        l.mobile ? (o = n.value) == null || o.setCurrentSlide(c) : (m = r.value) == null || m.setCurrentSlide(c);
      }
    });
    const i = v(() => l.list.length > 0);
    return He(() => {
      var c, o;
      i.value && (l.mobile ? (c = n.value) == null || c.setCurrentSlide(a.value) : (o = r.value) == null || o.setCurrentSlide(a.value));
    }), (c, o) => !c.mobile && i.value ? (d(), _(bo, {
      key: 0,
      list: c.list,
      options: s.value,
      ref: "desktopSlider"
    }, null, 8, ["list", "options"])) : i.value ? (d(), _(So, {
      key: 1,
      list: c.list,
      options: s.value,
      ref: "mobileSlider"
    }, null, 8, ["list", "options"])) : S("", !0);
  }
});
function wo(t, e) {
  if (!t || !e) return t;
  let l = "", s = 0;
  for (let r = 0; r < e.length; r++) {
    const n = e[r], a = t[s];
    if (s >= t.length) break;
    n === "0" ? /\d/.test(a) ? (l += a, s++) : (s++, r--) : (l += n, a === n && s++);
  }
  return l;
}
const $o = { class: "mm-menu__content" }, Bo = /* @__PURE__ */ I({
  __name: "MMMenuContent",
  props: /* @__PURE__ */ oe({
    offset: {},
    position: {},
    fullWidth: { type: Boolean },
    tail: { type: Boolean },
    animation: { default: "slide" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, l = le(t, "modelValue"), s = yt("triggerRef"), r = ne("menu"), n = it(r, {
      width: 100,
      height: 100
    }), a = Rt(s), { width: i, height: c } = Mt(), o = $(!1), m = $({
      angle: 90,
      left: 0,
      top: 0
    }), u = v(() => {
      switch (e.animation) {
        case "slide":
          return "opacity .2s, transform .2s";
        case "fade":
          return "opacity .2s";
        default:
          return "none";
      }
    });
    function y() {
      if (!window) return {};
      const C = window.scrollY, P = window.scrollX, p = e.offset || 0, f = 4, W = (a == null ? void 0 : a.top.value) + C, H = i.value - (a == null ? void 0 : a.right.value) - P, L = c.value - (a == null ? void 0 : a.bottom.value) - C, U = (a == null ? void 0 : a.left.value) + P;
      if (W === void 0 || H === void 0 || L === void 0 || U === void 0)
        return {};
      const Y = a == null ? void 0 : a.width.value, E = a == null ? void 0 : a.height.value;
      if (Y === void 0 || E === void 0) return {};
      const w = n == null ? void 0 : n.width.value, x = n == null ? void 0 : n.height.value;
      if (w === 0 || x === 0) return {};
      let Z = 0;
      if (w > Y) {
        const be = w - Y;
        H < be / 2 && (Z = -(be / 2)), U < be / 2 && (Z = be / 2);
      }
      const F = U + Y / 2 - w / 2, me = {
        top: `${W + E / 2 - x / 2}px`,
        left: `${F}px`,
        transformOrigin: "center center",
        width: e.fullWidth ? `${Y}px` : "max-content",
        "--transition": u.value
      };
      o.value = !0;
      const fe = 20, Me = 8, ge = 8;
      let ve = w / 2 - fe / 2 - Z;
      ve < 0 && (ve = ge), ve > w - fe && (ve = w - fe - ge);
      const Pe = B();
      switch ((Pe === "top" || Pe === "bottom") && Y < fe + ge && (Z < 0 && (me.left = `${F + ge / 2 + fe / 2}px`), Z > 0 && (me.left = `${F - ge / 2 - fe / 2}px`)), Pe) {
        case "top":
          return m.value = {
            angle: 180,
            left: ve,
            top: x - 1
          }, {
            ...me,
            transform: `translate(${Z}px, ${-x / 2 - p - E / 2}px)`,
            paddingBottom: `${p + f}px`
          };
        case "bottom":
          return m.value = {
            angle: 0,
            left: ve,
            top: -7
          }, {
            ...me,
            transform: `translate(${Z}px, ${x / 2 - f + E / 2}px)`,
            paddingTop: `${p + f}px`
          };
        case "right":
          return m.value = {
            angle: -90,
            left: -8 * 2 + 3,
            top: x / 2 - Me / 2
          }, {
            ...me,
            transform: `translate(${w / 2 - f + Y / 2}px, ${x / 2 - E / 2}px)`,
            paddingLeft: `${p + f}px`
          };
        case "left":
          return m.value = {
            angle: 90,
            left: w - Me + 1,
            top: x / 2 - Me / 2
          }, {
            ...me,
            transform: `translate(${-w / 2 - p - Y / 2}px, ${x / 2 - E / 2}px)`,
            paddingRight: `${p + f}px`
          };
      }
    }
    const b = $({}), h = v(() => ({
      model: l.value,
      menuSizeWidth: n.width.value,
      width: i.value,
      height: c.value,
      scrollX: window.scrollX,
      scrollY: window.scrollY,
      triggerRectLeft: a.left.value,
      triggerRectRight: a.right.value,
      triggerRectTop: a.top.value,
      triggerRectBottom: a.bottom.value,
      triggerRectWidth: a.width.value,
      triggerRectHeight: a.height.value,
      offset: e.offset,
      position: e.position
    }));
    G(h, () => {
      o.value = !1, b.value = y();
    });
    function B() {
      const C = a.top.value < n.height.value + (e.offset || 0), P = a.bottom.value + n.height.value > c.value, p = i.value < a.right.value + n.width.value + (e.offset || 0) + 16, f = a.left.value < n.width.value + (e.offset || 0);
      return e.position === "top" && !C ? "top" : e.position === "bottom" && !P ? "bottom" : e.position === "right" && !p ? "right" : e.position === "left" && !f ? "left" : C ? P ? p ? f ? "bottom" : "left" : "right" : "bottom" : "top";
    }
    return (C, P) => (d(), _(Se, { name: "menu-fade" }, {
      default: V(() => [
        l.value ? (d(), k("div", {
          key: 0,
          class: D(["mm-menu", { "mm-menu--visible": o.value }]),
          ref: "menu",
          style: Q(b.value)
        }, [
          R("div", $o, [
            e.tail ? (d(), _(g(N), {
              key: 0,
              class: "mm-menu__tail",
              name: "tail",
              angle: m.value.angle,
              height: 8,
              width: 20,
              style: Q({
                left: m.value.left + "px",
                top: m.value.top + "px"
              })
            }, null, 8, ["angle", "style"])) : S("", !0),
            A(C.$slots, "default", {}, void 0, !0)
          ])
        ], 6)) : S("", !0)
      ]),
      _: 3
    }));
  }
}), Co = /* @__PURE__ */ T(Bo, [["__scopeId", "data-v-f6ef8a35"]]), Lo = {
  key: 0,
  class: "mm-menu-wrapper__overlay"
}, Vo = /* @__PURE__ */ I({
  __name: "MMMenu",
  props: /* @__PURE__ */ oe({
    offset: { default: 8 },
    manual: { type: Boolean, default: !1 },
    hoverable: { type: Boolean, default: !1 },
    position: { default: "bottom" },
    fullWidth: { type: Boolean, default: !1 },
    tail: { type: Boolean, default: !1 },
    animation: { default: "fade" },
    preventDefaultClick: { type: Boolean, default: !1 },
    overlay: { type: Boolean }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, l = le(t, "modelValue"), s = ne("trigger"), r = ne("menu"), n = Te(r), a = Te(s);
    Pt(
      r,
      () => {
        e.manual || (l.value = !1);
      },
      {
        ignore: [s]
      }
    );
    const i = v(() => a.sourceType.value === "touch" || n.sourceType.value === "touch");
    He(() => {
      if (!e.hoverable || e.manual) return;
      const u = !n.isOutside.value || !a.isOutside.value;
      u && i.value || (l.value = u);
    });
    const c = (u) => {
      e.preventDefaultClick && u.preventDefault(), !(e.manual || e.hoverable && !i.value) && (l.value = !l.value);
    }, o = $(!1), m = $(null);
    return G(l, (u) => {
      u ? (m.value && clearTimeout(m.value), o.value = !0) : m.value = setTimeout(() => {
        o.value = !1;
      }, 200);
    }, { immediate: !0 }), _t("triggerRef", s), (u, y) => (d(), k("div", {
      class: D(["mm-menu-wrapper", { "mm-menu-wrapper--overlay": u.overlay }])
    }, [
      O(Se, { name: "fade" }, {
        default: V(() => [
          u.overlay && l.value ? (d(), k("div", Lo)) : S("", !0)
        ]),
        _: 1
      }),
      u.$slots.default ? (d(), k("div", {
        key: 0,
        class: "mm-menu-wrapper__trigger",
        ref: "trigger",
        onClick: c
      }, [
        A(u.$slots, "default", {}, void 0, !0)
      ], 512)) : S("", !0),
      o.value ? (d(), _(ze, {
        key: 1,
        to: "body"
      }, [
        O(Co, {
          modelValue: l.value,
          "onUpdate:modelValue": y[0] || (y[0] = (b) => l.value = b),
          ref: "menu",
          offset: u.offset,
          position: u.position,
          "full-width": u.fullWidth,
          tail: u.tail,
          animation: u.animation
        }, {
          default: V(() => [
            A(u.$slots, "content", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["modelValue", "offset", "position", "full-width", "tail", "animation"])
      ])) : S("", !0)
    ], 2));
  }
}), $e = /* @__PURE__ */ T(Vo, [["__scopeId", "data-v-4d9c453c"]]), Ro = {
  key: 0,
  class: "mm-input__required"
}, Mo = { class: "mm-input__input-container" }, Po = ["type", "maxlength", "autocomplete", "disabled"], Io = /* @__PURE__ */ I({
  __name: "MMInput",
  props: /* @__PURE__ */ oe({
    required: { type: Boolean },
    error: {},
    design: { default: "filled" },
    size: { default: "M40" },
    prefix: {},
    postfix: {},
    placeholder: {},
    label: {},
    maxLength: {},
    mask: {},
    clearable: { type: Boolean, default: !0 },
    type: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ oe(["input", "change", "keydown", "focus", "blur", "click-prefix", "click-postfix", "clear"], ["update:modelValue"]),
  setup(t, { expose: e, emit: l }) {
    const s = t, r = l, n = le(t, "modelValue");
    He(() => {
      s.mask ? n.value = wo(n.value || "", s.mask) : n.value = n.value || "";
    });
    const a = $(!1), i = v(() => !!n.value), c = () => {
      a.value = !0, r("focus");
    }, o = () => {
      a.value = !1, r("blur");
    }, m = v(() => [
      `design-${s.design}`,
      `size-${s.size}`,
      {
        error: !!s.error,
        focused: a.value,
        disabled: s.disabled
      }
    ]), u = () => !1, y = (p) => {
      var f;
      (f = s.prefix) != null && f.clickable && (p.preventDefault(), r("click-prefix"));
    }, b = (p) => {
      var f;
      (f = s.postfix) != null && f.clickable && (p.preventDefault(), r("click-postfix"));
    }, h = v(
      () => {
        var p, f;
        return ((p = s.prefix) == null ? void 0 : p.offset) !== void 0 ? (f = s.prefix) == null ? void 0 : f.offset : 12;
      }
    ), B = v(
      () => {
        var p, f;
        return ((p = s.postfix) == null ? void 0 : p.offset) !== void 0 ? (f = s.postfix) == null ? void 0 : f.offset : 12;
      }
    );
    function C() {
      s.clearable && !s.disabled && (n.value = "", r("clear"));
    }
    const P = ne("input");
    return e({
      focus() {
        var p;
        (p = P.value) == null || p.focus();
      },
      blur() {
        var p;
        (p = P.value) == null || p.blur();
      }
    }), (p, f) => (d(), _(g(Re), {
      class: "mm-input",
      error: s.error
    }, {
      default: V(() => {
        var W, H, L, U, Y, E, w, x, Z;
        return [
          p.label ? (d(), _(z, {
            key: 0,
            class: "mm-input__label",
            font: "Caption L/Regular"
          }, {
            default: V(() => [
              R("span", null, X(p.label), 1),
              p.required ? (d(), k("span", Ro, "*")) : S("", !0)
            ]),
            _: 1
          })) : S("", !0),
          R("div", {
            class: D(["mm-input__container", m.value])
          }, [
            p.prefix ? (d(), _(ce((W = s.prefix) != null && W.hint ? g($e) : "div"), {
              key: 0,
              hoverable: !!((H = s.prefix) != null && H.hint),
              class: D(["mm-input__prefix", { clickable: !!((L = p.prefix) != null && L.clickable) }]),
              style: Q({
                marginLeft: `${h.value}px`,
                width: `${(U = p.prefix) == null ? void 0 : U.width}px`
              }),
              onClick: y
            }, {
              content: V(() => [
                O(z, {
                  font: "Caption L/Regular",
                  class: "mm-input__prefix-hint"
                }, {
                  default: V(() => {
                    var F;
                    return [
                      q(X((F = s.prefix) == null ? void 0 : F.hint), 1)
                    ];
                  }),
                  _: 1
                })
              ]),
              default: V(() => [
                p.prefix.icon ? (d(), _(N, ie(j({ key: 0 }, p.prefix.icon)), null, 16)) : S("", !0),
                p.prefix.text ? (d(), _(z, ie(j({ key: 1 }, p.prefix.text)), null, 16)) : S("", !0),
                p.prefix.button ? (d(), _(g(ee), j({ key: 2 }, p.prefix.button, { type: "button" }), null, 16)) : S("", !0)
              ]),
              _: 1
            }, 8, ["hoverable", "class", "style"])) : S("", !0),
            R("div", Mo, [
              De(R("input", {
                class: "mm-input__input",
                ref: "input",
                "onUpdate:modelValue": f[0] || (f[0] = (F) => n.value = F),
                type: s.type,
                maxlength: p.maxLength,
                autocomplete: s.autocomplete,
                disabled: s.disabled,
                onFocus: c,
                onBlur: o,
                onInput: f[1] || (f[1] = (F) => p.$emit("input", F)),
                onChange: f[2] || (f[2] = (F) => p.$emit("change", F)),
                onKeypress: u
              }, null, 40, Po), [
                [kt, n.value]
              ]),
              p.placeholder ? (d(), _(z, {
                key: 0,
                class: D(["mm-input__placeholder", { visible: !a.value && !i.value }]),
                font: "Caption L/Regular",
                label: p.placeholder
              }, null, 8, ["label", "class"])) : S("", !0)
            ]),
            p.clearable && !p.disabled ? (d(), k("div", {
              key: 1,
              class: D(["mm-input__clear", { visible: i.value }]),
              onClick: C
            }, [
              O(g(ee), {
                design: "Text",
                type: "button",
                "prefix-icon": {
                  name: "close"
                }
              })
            ], 2)) : S("", !0),
            p.postfix ? (d(), _(ce((Y = s.postfix) != null && Y.hint ? g($e) : "div"), {
              key: 2,
              class: D(["mm-input__postfix", { clickable: !!((E = p.postfix) != null && E.clickable) }]),
              style: Q({
                marginRight: `${B.value}px`,
                width: `${(w = p.postfix) == null ? void 0 : w.width}px`
              }),
              hoverable: !!((x = s.postfix) != null && x.hint),
              tail: !!((Z = s.postfix) != null && Z.hint),
              onClick: b
            }, {
              content: V(() => [
                O(z, {
                  font: "Caption L/Regular",
                  color: "inverse-primary",
                  class: "mm-input__postfix-hint"
                }, {
                  default: V(() => {
                    var F;
                    return [
                      q(X((F = s.postfix) == null ? void 0 : F.hint), 1)
                    ];
                  }),
                  _: 1
                })
              ]),
              default: V(() => [
                p.postfix.text ? (d(), _(z, ie(j({ key: 0 }, p.postfix.text)), null, 16)) : S("", !0),
                p.postfix.icon ? (d(), _(N, ie(j({ key: 1 }, p.postfix.icon)), null, 16)) : S("", !0),
                p.postfix.button ? (d(), _(g(ee), j({ key: 2 }, p.postfix.button, { type: "button" }), null, 16)) : S("", !0)
              ]),
              _: 1
            }, 8, ["class", "style", "hoverable", "tail"])) : S("", !0)
          ], 2)
        ];
      }),
      _: 1
    }, 8, ["error"]));
  }
}), pe = /* @__PURE__ */ T(Io, [["__scopeId", "data-v-711bb9dc"]]), ps = /* @__PURE__ */ I({
  __name: "MMInputEmail",
  props: /* @__PURE__ */ oe({
    required: { type: Boolean },
    error: {},
    design: {},
    size: {},
    prefix: {},
    postfix: { default: () => ({
      icon: {
        name: "mail-outlined",
        color: "disabled"
      }
    }) },
    placeholder: { default: "Введите email" },
    label: {},
    maxLength: {},
    mask: {},
    clearable: { type: Boolean, default: !0 },
    type: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, l = le(t, "modelValue");
    return (s, r) => (d(), _(pe, j(e, {
      modelValue: l.value,
      "onUpdate:modelValue": r[0] || (r[0] = (n) => l.value = n),
      type: "email"
    }), null, 16, ["modelValue"]));
  }
});
function ms(t) {
  let e = t.replace(/\D/g, "");
  e = e.slice(0, 10);
  let l = "";
  return e.length > 0 && (l += `(${e.slice(0, 3)}`), e.length > 3 && (l += `) ${e.slice(3, 6)}`), e.length > 6 && (l += `-${e.slice(6, 8)}`), e.length > 8 && (l += `-${e.slice(8, 10)}`), l;
}
function Do(t) {
  return t.replace(/\D/g, "").slice(0, 10);
}
function fs(t) {
  let e = t.replace(/\D/g, "");
  e = e.slice(0, 8);
  let l = "";
  return e.length === 1 ? l += e : (e.length > 1 && (l += `${e.slice(0, 2)}`), e.length > 2 && (l += `-${e.slice(2, 3)}`), e.length > 3 && (l += `${e.slice(3, 4)}`), e.length > 4 && (l += `-${e.slice(4, 8)}`), l);
}
const vs = /* @__PURE__ */ I({
  __name: "MMInputPhone",
  props: /* @__PURE__ */ oe({
    required: { type: Boolean },
    error: {},
    design: {},
    size: {},
    prefix: { default: () => ({
      text: {
        font: "Caption L/Regular",
        color: "disabled",
        label: "+7"
      }
    }) },
    postfix: {},
    placeholder: { default: "Введите телефон" },
    label: {},
    maxLength: {},
    mask: {},
    clearable: { type: Boolean, default: !0 },
    type: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, l = le(t, "modelValue"), s = $();
    return G(l, (r) => {
      s.value = (r == null ? void 0 : r.slice(1)) || "";
    }, { immediate: !0 }), G(s, (r) => {
      r ? l.value = `7${Do(r)}` : l.value = "";
    }), (r, n) => (d(), _(pe, j(e, {
      type: "tel",
      modelValue: s.value,
      "onUpdate:modelValue": n[0] || (n[0] = (a) => s.value = a),
      mask: "(000) 000-00-00"
    }), null, 16, ["modelValue"]));
  }
}), hs = /* @__PURE__ */ I({
  __name: "MMInputDate",
  props: /* @__PURE__ */ oe({
    required: { type: Boolean },
    error: {},
    design: {},
    size: {},
    prefix: {},
    postfix: { default: () => ({
      text: {
        font: "Caption L/Regular",
        color: "disabled",
        label: "ДД.ММ.ГГГГ"
      }
    }) },
    placeholder: { default: "Введите дату" },
    label: {},
    maxLength: {},
    mask: {},
    clearable: { type: Boolean, default: !0 },
    type: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: e }) {
    const l = t, s = le(t, "modelValue"), r = v(() => ke(s.value, "DD-MM-YYYY", !0).isValid());
    return e({
      isValid: r
    }), (n, a) => (d(), _(pe, j(l, {
      type: "tel",
      modelValue: s.value,
      "onUpdate:modelValue": a[0] || (a[0] = (i) => s.value = i),
      mask: "00-00-0000"
    }), null, 16, ["modelValue"]));
  }
}), To = {
  key: 0,
  class: "mm-input-menu__content-loader"
}, Oo = { key: 1 }, Wo = /* @__PURE__ */ I({
  __name: "MMInputMenu",
  props: /* @__PURE__ */ oe({
    required: { type: Boolean },
    error: {},
    design: {},
    size: {},
    prefix: {},
    postfix: {},
    placeholder: {},
    label: {},
    maxLength: {},
    mask: {},
    clearable: { type: Boolean, default: !0 },
    type: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean },
    loading: { type: Boolean, default: !0 },
    manual: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {},
    menu: { type: Boolean, default: !1 },
    menuModifiers: {}
  }),
  emits: /* @__PURE__ */ oe(["open", "close", "focus", "blur", "click-prefix", "click-postfix"], ["update:modelValue", "update:menu"]),
  setup(t, { emit: e }) {
    const l = t, s = e, r = le(t, "modelValue"), n = le(t, "menu"), a = $(!1), i = () => {
      s("focus"), a.value = !0, !l.manual && (n.value = !0);
    }, c = () => {
      s("blur"), a.value = !1, !l.manual && (n.value = !1);
    };
    return G(n, (o) => {
      s(o ? "open" : "close");
    }), (o, m) => (d(), _(g($e), {
      class: D(["mm-input-menu", { menu_opened: !!n.value }]),
      "full-width": "",
      manual: "",
      offset: 0,
      "content-class": "",
      modelValue: n.value,
      "onUpdate:modelValue": m[3] || (m[3] = (u) => n.value = u)
    }, {
      content: V(() => [
        R("div", {
          class: D(["mm-input-menu__content", { focused: a.value }])
        }, [
          O(we, { name: "mm-input-menu-fade" }, {
            default: V(() => [
              o.loading ? (d(), k("div", To, [
                O(N, {
                  name: "circular-loader-dark",
                  color: "primary",
                  animation: "rotation",
                  width: 56,
                  height: 56
                })
              ])) : (d(), k("div", Oo, [
                A(o.$slots, "default", {}, void 0, !0)
              ]))
            ]),
            _: 3
          })
        ], 2)
      ]),
      default: V(() => [
        O(pe, j(l, {
          modelValue: r.value,
          "onUpdate:modelValue": m[0] || (m[0] = (u) => r.value = u),
          onFocus: i,
          onBlur: c,
          onClickPrefix: m[1] || (m[1] = (u) => o.$emit("click-prefix")),
          onClickPostfix: m[2] || (m[2] = (u) => o.$emit("click-postfix"))
        }), null, 16, ["modelValue"])
      ]),
      _: 3
    }, 8, ["class", "modelValue"]));
  }
}), gs = /* @__PURE__ */ T(Wo, [["__scopeId", "data-v-5f669cf9"]]), xo = /* @__PURE__ */ I({
  __name: "MMInputCounter",
  props: /* @__PURE__ */ oe({
    required: { type: Boolean },
    error: {},
    design: {},
    size: {},
    placeholder: {},
    label: {},
    maxLength: {},
    mask: {},
    clearable: { type: Boolean, default: !1 },
    type: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean },
    min: {},
    max: {},
    alreadyMinHint: {},
    alreadyMaxHint: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, l = v(() => a.value === e.min), s = v(() => ({
      icon: {
        name: "minus",
        color: l.value ? "disabled" : "primary"
      },
      clickable: !l.value,
      hint: l.value ? e.alreadyMinHint : void 0
    })), r = v(() => a.value === e.max), n = v(() => ({
      icon: {
        name: "plus",
        color: r.value ? "disabled" : "primary"
      },
      clickable: !r.value,
      hint: r.value ? e.alreadyMaxHint : void 0
    })), a = le(t, "modelValue"), i = $(""), c = ne("input");
    G(
      a,
      (h) => {
        if (!u(h || 0)) {
          const C = y(h || 0);
          i.value = C.toString(), a.value = C;
          return;
        }
        const B = h == null ? void 0 : h.toString().replace(/[^0-9-]/g, "");
        i.value = B || "0";
      },
      { immediate: !0 }
    ), G(i, (h) => {
      if (!u(parseInt(h))) {
        i.value = y(parseInt(h)).toString(), b();
        return;
      }
      const C = h == null ? void 0 : h.toString().replace(/[^0-9-]/g, "");
      a.value = parseInt(C) || 0, i.value = C || "0";
    });
    const o = () => {
      if (e.disabled) return;
      const h = a.value || 0;
      u(h + 1) && (a.value = h + 1);
    }, m = () => {
      if (e.disabled) return;
      const h = a.value || 0;
      u(h - 1) && (a.value = h - 1);
    };
    function u(h) {
      return e.min && h < e.min ? !1 : !(e.max && h > e.max);
    }
    function y(h) {
      return e.min && h < e.min ? e.min : e.max && h > e.max ? e.max : h;
    }
    function b() {
      var h;
      (h = c.value) == null || h.blur(), _e(() => {
        var B;
        (B = c.value) == null || B.focus();
      });
    }
    return (h, B) => (d(), _(pe, j(e, {
      modelValue: i.value,
      "onUpdate:modelValue": B[0] || (B[0] = (C) => i.value = C),
      onClickPrefix: m,
      onClickPostfix: o,
      prefix: s.value,
      postfix: n.value,
      class: "mm-input-counter",
      ref: "input"
    }), null, 16, ["modelValue", "prefix", "postfix"]));
  }
}), bs = /* @__PURE__ */ T(xo, [["__scopeId", "data-v-270e63ec"]]), Ao = /* @__PURE__ */ I({
  __name: "MMLink",
  props: {
    design: { default: "neutral" },
    underline: { default: "none" },
    to: {},
    font: { default: "Body M/Regular" },
    target: { default: "_self" },
    disabled: { type: Boolean },
    label: {},
    active: { type: Boolean }
  },
  setup(t) {
    const e = t, l = ["http", "mailto", "tel"], s = v(() => {
      const a = e.to;
      return typeof a == "string" ? !l.some((i) => a.startsWith(i)) : !0;
    }), r = v(() => ({
      "mm-link": !0,
      disabled: e.disabled,
      [`mm-link_design-${e.design}`]: !0,
      [`mm-link_underline-${e.underline}`]: !0,
      active: e.active
    })), n = v(() => e.to ? s.value ? "router-link" : "a" : "span");
    return (a, i) => (d(), _(ce(n.value), j({
      class: r.value,
      target: a.target
    }, s.value ? { to: a.to } : { href: a.to }), {
      default: V(() => [
        A(a.$slots, "prepend", {}, void 0, !0),
        a.label ? (d(), _(g(z), {
          key: 0,
          tag: "span",
          label: a.label,
          font: a.font
        }, null, 8, ["label", "font"])) : S("", !0),
        A(a.$slots, "default", {}, void 0, !0),
        A(a.$slots, "append", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class", "target"]));
  }
}), ys = /* @__PURE__ */ T(Ao, [["__scopeId", "data-v-43b33fb3"]]), Ho = {
  font: "Body M/Semibold"
}, zo = {
  font: "Body S/Regular"
}, Je = $(5e3), Qe = $("bottom-center"), Ze = $("neutral"), Fe = $(!0), Ee = $(2), he = $([]);
function mt() {
  function t(r) {
    const n = typeof r.title == "string" ? { ...Ho, label: r.title } : r.title, a = typeof r.description == "string" ? { ...zo, label: r.description } : r.description, i = Ue();
    he.value.push({
      id: i,
      title: n,
      description: a,
      icon: r.icon,
      image: r.image,
      action: r.action,
      position: r.position || Qe.value,
      type: r.type || Ze.value,
      closable: r.closable ?? Fe.value,
      lifetime: r.lifetime || Je.value,
      createdAt: Date.now(),
      actionCallback: r.actionCallback
    });
  }
  function e(r) {
    he.value = he.value.filter(
      (n) => n.id !== r
    );
  }
  function l(r, n) {
    he.value = he.value.map(
      (a) => a.id === r ? n : a
    );
  }
  function s({
    lifetime: r,
    position: n,
    type: a,
    closable: i,
    maxNotificationsInPosition: c
  }) {
    Je.value = r, Qe.value = n, Ze.value = a, Fe.value = i, Ee.value = c;
  }
  return {
    notifications: he,
    defaultMaxNotificationsInPosition: Ee,
    createNotification: t,
    removeNotification: e,
    updateNotification: l,
    updateConfig: s
  };
}
const Uo = {
  key: 0,
  class: "mm-notification__icon"
}, Yo = { class: "mm-notification__content" }, jo = /* @__PURE__ */ I({
  __name: "MMNotification",
  props: {
    notification: {}
  },
  setup(t) {
    const e = t, l = v(() => ({
      [`mm-notification--${e.notification.type}`]: !0,
      closable: e.notification.closable
    }));
    function s() {
      var o, m;
      (m = (o = e.notification).actionCallback) == null || m.call(o), r(e.notification.id);
    }
    const { removeNotification: r } = mt(), n = $(null);
    c();
    function a() {
      n.value && clearTimeout(n.value);
    }
    function i() {
      c();
    }
    function c() {
      n.value = setTimeout(() => {
        r(e.notification.id);
      }, e.notification.lifetime);
    }
    return (o, m) => (d(), k("div", {
      class: D(["mm-notification", l.value]),
      onMouseenter: a,
      onMouseleave: i
    }, [
      o.notification.icon || o.notification.image ? (d(), k("div", Uo, [
        o.notification.icon ? (d(), _(g(N), ie(j({ key: 0 }, o.notification.icon)), null, 16)) : o.notification.image ? (d(), _(g(Ye), {
          key: 1,
          src: o.notification.image
        }, null, 8, ["src"])) : S("", !0)
      ])) : S("", !0),
      R("div", Yo, [
        O(g(z), ie(lt(o.notification.title)), null, 16),
        o.notification.description ? (d(), _(g(z), ie(j({ key: 0 }, o.notification.description)), null, 16)) : S("", !0)
      ]),
      o.notification.action ? (d(), _(g(ee), j({ key: 1 }, o.notification.action, { onClick: s }), null, 16)) : S("", !0),
      o.notification.closable ? (d(), _(g(ee), {
        key: 2,
        design: "Text",
        round: "",
        size: "XS28",
        class: "mm-notification__close",
        "prefix-icon": { name: "dismiss-filled" },
        onClick: m[0] || (m[0] = (u) => g(r)(o.notification.id))
      })) : S("", !0)
    ], 34));
  }
}), Xo = /* @__PURE__ */ T(jo, [["__scopeId", "data-v-7c988d61"]]), qo = /* @__PURE__ */ I({
  __name: "MMNotificationsContainer",
  setup(t) {
    const { notifications: e, defaultMaxNotificationsInPosition: l } = mt(), s = v(() => e.value.reduce(
      (n, a) => (n[a.position] = [
        ...n[a.position] || [],
        a
      ], n),
      {}
    )), r = [
      "top-left",
      "top-center",
      "top-right",
      "bottom-left",
      "bottom-center",
      "bottom-right"
    ];
    return (n, a) => (d(), k(J, null, te(r, (i) => R("div", {
      class: D(["mm-notifications-container", `mm-notifications-container--${i}`]),
      key: i
    }, [
      O(we, { name: "mm-notification-transition" }, {
        default: V(() => {
          var c;
          return [
            (d(!0), k(J, null, te((c = s.value[i]) == null ? void 0 : c.reverse().slice(0, g(l)), (o) => (d(), _(Xo, {
              key: o.id,
              notification: o
            }, null, 8, ["notification"]))), 128))
          ];
        }),
        _: 2
      }, 1024)
    ], 2)), 64));
  }
}), _s = /* @__PURE__ */ T(qo, [["__scopeId", "data-v-060b4ab9"]]), ue = class ue {
  constructor() {
    M(this, "popupIds", /* @__PURE__ */ new Set());
    M(this, "isLocked", !1);
    M(this, "unlockTimeout", null);
  }
  static getInstance() {
    return ue.instance || (ue.instance = new ue()), ue.instance;
  }
  addPopup(e) {
    this.popupIds.add(e), this.updateScrollLock();
  }
  removePopup(e) {
    this.popupIds.delete(e), this.updateScrollLock();
  }
  updateScrollLock() {
    const e = this.popupIds.size > 0;
    e !== this.isLocked && (this.isLocked = e, e ? this.lockScroll() : this.unlockScroll());
  }
  isScrollLocked() {
    return this.isLocked;
  }
  fixScrollbarBouncing() {
    const e = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${e}px`;
  }
  lockScroll() {
    this.unlockTimeout && clearTimeout(this.unlockTimeout), this.fixScrollbarBouncing();
    const e = window.scrollY;
    document.body.style.position = "fixed", document.body.style.top = `-${e}px`, document.body.style.overscrollBehaviorY = "contain";
  }
  unlockScroll() {
    this.unlockTimeout && clearTimeout(this.unlockTimeout), this.unlockTimeout = setTimeout(() => {
      const e = Math.abs(parseInt(document.body.style.top || "0"));
      document.body.style.position = "", document.body.style.top = "", document.body.style.overscrollBehaviorY = "auto", window.scrollTo(0, e);
    }, 200);
  }
};
M(ue, "instance");
let We = ue;
const xe = We.getInstance(), Go = /* @__PURE__ */ I({
  __name: "PopupBase",
  props: {
    popup: {}
  },
  setup(t) {
    const e = t;
    st(() => xe.removePopup(e.popup.id));
    const l = $(!1), s = $();
    async function r() {
      e.popup.options.isOverlayUnClickable || l.value || await e.popup.close();
    }
    function n(c) {
      var o;
      l.value = (o = s.value) == null ? void 0 : o.contains(c.target);
    }
    const a = v(() => e.popup.options.isBottomRight), i = v(() => {
      const { spacingTop: c, spacingBottom: o, withoutOverlay: m } = e.popup.options, u = m ? c ?? 0 : 0, y = m ? o ?? 0 : 0;
      return {
        paddingTop: `${u}px`,
        paddingBottom: `${y}px`
      };
    });
    return (c, o) => c.popup.isMounted ? (d(), _(ze, {
      key: 0,
      to: "body"
    }, [
      O(Se, {
        name: "popup-slide-fade",
        appear: ""
      }, {
        default: V(() => [
          c.popup.isShown ? (d(), k("div", {
            key: 0,
            class: D(["popup-base__overlay", { "popup-base__overlay_hidden": c.popup.options.withoutOverlay, "popup-base__overlay_bottom-right": a.value }]),
            style: Q(i.value),
            onClick: r,
            onMousedown: n
          }, [
            R("div", {
              class: "popup-base__popup",
              ref_key: "popupEL",
              ref: s
            }, [
              c.popup.component ? (d(), _(ce(c.popup.component), j({ key: 0 }, c.popup.props, {
                onShowData: c.popup.onShowData,
                onClose: o[0] || (o[0] = async (m) => await c.popup.close(m))
              }), null, 16, ["onShowData"])) : A(c.$slots, "default", { key: 1 }, void 0, !0)
            ], 512)
          ], 38)) : S("", !0)
        ]),
        _: 3
      })
    ])) : S("", !0);
  }
}), No = /* @__PURE__ */ T(Go, [["__scopeId", "data-v-80eaa71f"]]), Ko = 200;
class Jo {
  constructor(e) {
    M(this, "options");
    M(this, "component");
    M(this, "props");
    M(this, "onShowData");
    M(this, "_isMounted", !1);
    M(this, "_isShown", !1);
    M(this, "_id", Ue());
    M(this, "closeAnimationTimeout");
    M(this, "eventShow", qe(`mm-popup-show-event-${this._id}`));
    M(this, "eventClose", qe(`mm-popup-close-event-${this._id}`));
    M(this, "beforeCloseHandler");
    this.options = e.options ?? {}, this.component = e.component && St(e.component), this.props = e.props;
  }
  get isMounted() {
    return this._isMounted;
  }
  get isShown() {
    return this._isShown;
  }
  get id() {
    return this._id;
  }
  show(e) {
    clearTimeout(this.closeAnimationTimeout), this.options.noOwerflowLock || xe.addPopup(this._id), this.onShowData = e, this._isMounted = !0, _e(() => {
      this._isShown = !0, this.eventShow.emit(e);
    });
  }
  close(e) {
    if (typeof this.beforeCloseHandler != "function")
      return this._close(e);
    this.beforeCloseHandler().then(() => this._close(e)).catch(() => {
    });
  }
  _close(e) {
    this._isShown = !1, this.options.noOwerflowLock || xe.removePopup(this._id), this.closeAnimationTimeout = setTimeout(() => {
      this._isMounted = !1, this.eventClose.emit(e);
    }, Ko);
  }
  onShow(e) {
    return this.eventShow.on(e);
  }
  onClose(e) {
    return this.eventClose.on(e);
  }
  onBeforeClose(e) {
    const l = typeof e == "function";
    this.beforeCloseHandler = l ? e : void 0;
  }
  updateOptions(e) {
    this.options = e;
  }
}
const Be = $(/* @__PURE__ */ new Map());
function Qo() {
  Be.value.forEach((t) => t.close());
}
function Zo(t) {
  const e = wt(new Jo(t));
  return e.onShow(() => Be.value.set(e.id, e)), e.onClose(() => Be.value.delete(e.id)), e;
}
function Fo() {
  return { popups: Be, createPopup: Zo, closeAllPopups: Qo };
}
const ks = /* @__PURE__ */ I({
  __name: "MMPopupControllerTarget",
  setup(t) {
    const { popups: e, closeAllPopups: l } = Fo(), s = Ot();
    return G(() => s.path, () => l()), (r, n) => (d(!0), k(J, null, te(Array.from(g(e)), ([a, i]) => (d(), _(No, {
      key: a,
      popup: i
    }, null, 8, ["popup"]))), 128));
  }
}), Eo = { class: "mm-popup-default__body" }, el = {
  key: 0,
  class: "mm-popup-default__footer"
}, tl = /* @__PURE__ */ I({
  __name: "MMPopupDefault",
  props: {
    isClosable: { type: Boolean, default: !0 },
    hFull: { type: Boolean }
  },
  emits: ["close"],
  setup(t) {
    return (e, l) => (d(), k("div", {
      class: D(["mm-popup-default", { "mm-popup-default_h-full": e.hFull }])
    }, [
      R("div", {
        class: D(["mm-popup-default__header", { "mm-popup-default__header_closable": e.isClosable }])
      }, [
        A(e.$slots, "header", {}, void 0, !0)
      ], 2),
      R("div", Eo, [
        A(e.$slots, "default", {}, void 0, !0)
      ]),
      e.$slots.footer ? (d(), k("div", el, [
        A(e.$slots, "footer", {}, void 0, !0)
      ])) : S("", !0),
      e.isClosable ? (d(), _(g(ee), {
        key: 1,
        class: "mm-popup-default__close-button",
        "prefix-icon": {
          name: "dismiss-circle-multicolor",
          height: 24,
          width: 24
        },
        design: "Text",
        onClick: l[0] || (l[0] = (s) => e.$emit("close"))
      })) : S("", !0)
    ], 2));
  }
}), Ss = /* @__PURE__ */ T(tl, [["__scopeId", "data-v-fae25336"]]), ol = { class: "mm-popup-full-screen" }, ll = /* @__PURE__ */ I({
  __name: "MMPopupFullScreen",
  props: {
    isClosable: { type: Boolean }
  },
  emits: ["close"],
  setup(t) {
    return (e, l) => (d(), k("div", ol, [
      e.isClosable ? (d(), _(g(ee), {
        key: 0,
        class: "mm-popup-full-screen__close-button",
        "prefix-icon": {
          name: "dismiss-circle-multicolor",
          height: 24,
          width: 24
        },
        design: "Text",
        onClick: l[0] || (l[0] = (s) => e.$emit("close"))
      })) : S("", !0),
      A(e.$slots, "default", {}, void 0, !0)
    ]));
  }
}), ws = /* @__PURE__ */ T(ll, [["__scopeId", "data-v-1beab691"]]), sl = { class: "mm-popup-full-width" }, il = /* @__PURE__ */ I({
  __name: "MMPopupFullWidth",
  props: {
    isClosable: { type: Boolean }
  },
  emits: ["close"],
  setup(t) {
    return (e, l) => (d(), k("div", sl, [
      e.isClosable ? (d(), _(g(ee), {
        key: 0,
        class: "mm-popup-full-width__close-button",
        "prefix-icon": {
          name: "dismiss-circle-multicolor",
          height: 24,
          width: 24
        },
        design: "Text",
        onClick: l[0] || (l[0] = (s) => e.$emit("close"))
      })) : S("", !0),
      A(e.$slots, "default", {}, void 0, !0)
    ]));
  }
}), $s = /* @__PURE__ */ T(il, [["__scopeId", "data-v-e53fe974"]]), al = { class: "mm-popup-promo__body" }, nl = {
  key: 0,
  class: "mm-popup-promo__footer"
}, rl = /* @__PURE__ */ I({
  __name: "MMPopupPromo",
  props: {
    isClosable: { type: Boolean, default: !0 },
    hFull: { type: Boolean }
  },
  emits: ["close"],
  setup(t) {
    return (e, l) => (d(), k("div", {
      class: D(["mm-popup-promo", { "mm-popup-promo_h-full": e.hFull }])
    }, [
      R("div", {
        class: D(["mm-popup-promo__header", { "mm-popup-promo__header_closable": e.isClosable }])
      }, [
        A(e.$slots, "header", {}, void 0, !0)
      ], 2),
      R("div", al, [
        A(e.$slots, "default", {}, void 0, !0)
      ]),
      e.$slots.footer ? (d(), k("div", nl, [
        A(e.$slots, "footer", {}, void 0, !0)
      ])) : S("", !0),
      e.isClosable ? (d(), _(g(ee), {
        key: 1,
        class: "mm-popup-promo__close-button",
        "prefix-icon": {
          name: "dismiss-circle-multicolor",
          height: 24,
          width: 24
        },
        design: "Text",
        onClick: l[0] || (l[0] = (s) => e.$emit("close"))
      })) : S("", !0)
    ], 2));
  }
}), Bs = /* @__PURE__ */ T(rl, [["__scopeId", "data-v-550f5561"]]), ul = { class: "range-slider-fields" }, dl = { class: "range-slider-container" }, cl = ["min", "max", "step", "disabled"], pl = ["min", "max", "step", "disabled"], ml = /* @__PURE__ */ I({
  __name: "MMRange",
  props: {
    disabled: { type: Boolean },
    min: { default: 0 },
    max: { default: 100 },
    modelValue: { default: () => ({ lower: 20, upper: 80 }) },
    step: { default: 1 },
    instantUpdate: { type: Boolean },
    hasTextInputs: { type: Boolean, default: !0 },
    clearable: { type: Boolean },
    compact: { type: Boolean },
    lowerPrefix: {},
    lowerPostfix: {},
    upperPrefix: {},
    upperPostfix: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    var P, p;
    const l = t, s = $(l.min), r = $(l.max), n = $(l.modelValue.lower), a = $(l.modelValue.upper);
    G(
      () => l.modelValue,
      (f) => {
        B(f.lower, f.upper);
      }
    ), G(
      () => l.min,
      (f) => {
        B(f, a.value);
      }
    ), G(
      () => l.max,
      (f) => {
        B(n.value, f);
      }
    );
    const i = e, c = Ve(() => {
      B(), i("update:modelValue", {
        lower: n.value,
        upper: a.value
      });
    }, 300), o = (f) => {
      const W = f.target;
      n.value = Math.min(Number(W.value), a.value - 1), l.instantUpdate && c();
    }, m = (f) => {
      const W = f.target;
      a.value = Math.max(Number(W.value), n.value + 1), l.instantUpdate && c();
    }, u = $((P = n.value) == null ? void 0 : P.toString()), y = $((p = a.value) == null ? void 0 : p.toString()), b = () => {
      n.value = Number(u.value), c();
    }, h = () => {
      a.value = Number(y.value), c();
    };
    function B(f, W) {
      var U, Y;
      s.value = l.min, r.value = l.max, l.min === l.max && (r.value = l.max + 1), f || (f = n.value), W || (W = a.value);
      let H = Math.max(f, s.value), L = Math.min(W, r.value);
      H >= L && (L = Math.min(H + l.step, r.value)), L <= H && (H = Math.max(L - l.step, s.value)), n.value = H, u.value = (U = n.value) == null ? void 0 : U.toString(), a.value = L, y.value = (Y = a.value) == null ? void 0 : Y.toString();
    }
    const C = v(() => {
      const f = (n.value - s.value) / (r.value - s.value) * 100, W = (a.value - s.value) / (r.value - s.value) * 100;
      return {
        clipPath: `polygon(${f}% 0, ${W}% 0, ${W}% 100%, ${f}% 100%)`
      };
    });
    return (f, W) => (d(), k("div", {
      class: D(["range-slider", { disabled: f.disabled }])
    }, [
      R("div", ul, [
        O(g(pe), {
          modelValue: u.value,
          "onUpdate:modelValue": W[0] || (W[0] = (H) => u.value = H),
          clearable: f.clearable,
          prefix: f.lowerPrefix,
          postfix: f.lowerPostfix,
          onBlur: b,
          disabled: f.disabled
        }, null, 8, ["modelValue", "clearable", "prefix", "postfix", "disabled"]),
        O(g(pe), {
          modelValue: y.value,
          "onUpdate:modelValue": W[1] || (W[1] = (H) => y.value = H),
          clearable: f.clearable,
          prefix: f.upperPrefix,
          postfix: f.upperPostfix,
          onBlur: h,
          disabled: f.disabled
        }, null, 8, ["modelValue", "clearable", "prefix", "postfix", "disabled"])
      ]),
      R("div", dl, [
        W[6] || (W[6] = R("div", { class: "range-slider-container-track" }, null, -1)),
        R("div", {
          class: "range-slider-container-track filled",
          style: Q(C.value)
        }, null, 4),
        De(R("input", {
          type: "range",
          min: s.value,
          max: r.value,
          step: f.step,
          "onUpdate:modelValue": W[2] || (W[2] = (H) => n.value = H),
          onInput: o,
          onChange: W[3] || (W[3] = (H) => f.instantUpdate ? null : g(c)()),
          disabled: f.disabled
        }, null, 40, cl), [
          [je, n.value]
        ]),
        De(R("input", {
          type: "range",
          min: s.value,
          max: r.value,
          step: f.step,
          "onUpdate:modelValue": W[4] || (W[4] = (H) => a.value = H),
          onInput: m,
          onChange: W[5] || (W[5] = (H) => f.instantUpdate ? null : g(c)()),
          disabled: f.disabled
        }, null, 40, pl), [
          [je, a.value]
        ])
      ])
    ], 2));
  }
}), Cs = /* @__PURE__ */ T(ml, [["__scopeId", "data-v-f71b5e14"]]);
function ft(t) {
  return t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
function et(t, e) {
  const l = [2, 0, 1, 1, 1, 2], s = t % 100 > 4 && t % 100 < 20 ? 2 : l[Math.min(t % 10, 5)];
  return e[s];
}
function Ce(t, e, l = !0) {
  return t === void 0 ? "" : l ? `${ft(t)} ${et(t, e)}` : et(t, e);
}
const fl = /* @__PURE__ */ I({
  __name: "MMRatingCompact",
  props: {
    rating: {},
    reviewsCount: {},
    ordersCount: {}
  },
  emits: ["reviewsClick"],
  setup(t, { emit: e }) {
    const l = e, s = t, r = v(() => `· ${Ce(s.reviewsCount ?? 0, [
      "отзыв",
      "отзыва",
      "отзывов"
    ])}`), n = v(() => Ce(s.ordersCount ?? 0, ["заказ", "заказа", "заказов"])), a = () => {
      l("reviewsClick");
    };
    return (i, c) => (d(), k("div", {
      class: "mm-rating-compact",
      onClick: a
    }, [
      i.reviewsCount ? (d(), k(J, { key: 0 }, [
        O(g(N), {
          name: "star",
          class: "mm-rating-compact__stars",
          width: 14,
          height: 14
        }),
        O(g(z), {
          font: "Caption M/Regular",
          color: "tertiary"
        }, {
          default: V(() => {
            var o;
            return [
              q(X((o = i.rating) == null ? void 0 : o.toFixed(1)), 1)
            ];
          }),
          _: 1
        }),
        O(g(z), {
          font: "Caption M/Regular",
          color: "tertiary"
        }, {
          default: V(() => [
            q(X(r.value), 1)
          ]),
          _: 1
        })
      ], 64)) : S("", !0),
      !i.reviewsCount && i.ordersCount ? (d(), _(g(z), {
        key: 1,
        font: "Caption M/Regular",
        color: "tertiary"
      }, {
        default: V(() => [
          q(X(n.value), 1)
        ]),
        _: 1
      })) : S("", !0)
    ]));
  }
}), vl = /* @__PURE__ */ T(fl, [["__scopeId", "data-v-a659d5d5"]]), hl = { class: "mm-rating-mobile" }, gl = { class: "mm-rating-mobile__reviews-rating" }, bl = {
  key: 1,
  class: "mm-rating-mobile__orders"
}, yl = /* @__PURE__ */ I({
  __name: "MMRatingFull",
  props: {
    rating: {},
    reviewsCount: {},
    ordersCount: {},
    photosCount: {},
    photosPreviews: {}
  },
  emits: ["photosClick", "reviewsClick"],
  setup(t, { emit: e }) {
    const l = e, s = t, r = v(() => Ce(s.reviewsCount ?? 0, ["отзыв", "отзыва", "отзывов"])), n = v(() => Ce(
      s.ordersCount ?? 0,
      ["заказ", "заказа", "заказов"],
      !1
    )), a = v(() => s.photosCount && s.photosCount > 99 ? "99+" : s.photosCount), i = v(() => {
      var m;
      return (m = s.photosPreviews) == null ? void 0 : m.slice(0, 3);
    }), c = () => {
      l("photosClick");
    }, o = () => {
      l("reviewsClick");
    };
    return (m, u) => {
      var y;
      return d(), k("div", hl, [
        m.rating && m.reviewsCount ? (d(), k("div", {
          key: 0,
          class: "mm-rating-mobile__reviews",
          onClick: o
        }, [
          R("div", gl, [
            O(g(N), {
              name: "star",
              class: "mm-rating-mobile__reviews-rating-icon",
              height: 14,
              width: 14
            }),
            O(g(z), { font: "Body M/Semibold" }, {
              default: V(() => [
                q(X(m.rating.toFixed(1)), 1)
              ]),
              _: 1
            })
          ]),
          O(g(z), {
            font: "Body S/Regular",
            color: "tertiary",
            class: "mm-rating-mobile__reviews-count"
          }, {
            default: V(() => [
              q(X(r.value), 1)
            ]),
            _: 1
          })
        ])) : S("", !0),
        m.ordersCount ? (d(), k("div", bl, [
          O(g(z), { font: "Body M/Semibold" }, {
            default: V(() => [
              q(X(g(ft)(m.ordersCount)) + "+ ", 1)
            ]),
            _: 1
          }),
          O(g(z), {
            font: "Body S/Regular",
            color: "tertiary"
          }, {
            default: V(() => [
              q(X(n.value), 1)
            ]),
            _: 1
          })
        ])) : S("", !0),
        (y = i.value) != null && y.length ? (d(), k("div", {
          key: 2,
          class: "mm-rating-mobile__photos",
          onClick: c
        }, [
          (d(!0), k(J, null, te(i.value, (b, h) => (d(), k("div", {
            class: "mm-rating-mobile__photos-item",
            key: b
          }, [
            (d(), _(g(Ye), {
              key: b,
              src: b
            }, null, 8, ["src"])),
            m.photosCount && m.photosCount > 3 && h === i.value.length - 1 ? (d(), _(g(z), {
              key: 0,
              font: "Body M/Semibold",
              color: "inverse-primary",
              class: "mm-rating-mobile__photos-count"
            }, {
              default: V(() => [
                q(X(a.value), 1)
              ]),
              _: 1
            })) : S("", !0)
          ]))), 128))
        ])) : S("", !0)
      ]);
    };
  }
}), _l = /* @__PURE__ */ T(yl, [["__scopeId", "data-v-75413eb4"]]), kl = { class: "mm-rating-stars" }, Sl = /* @__PURE__ */ I({
  __name: "MMRatingStars",
  props: {
    rating: {}
  },
  setup(t) {
    const e = t, l = v(() => ({
      clipPath: `inset(0 0 0 ${(e.rating ?? 0) / 5 * 100}%)`
    }));
    return (s, r) => (d(), k("div", kl, [
      O(g(N), {
        name: "stars",
        class: "mm-rating-stars__filled",
        height: 28,
        width: 120
      }),
      O(g(N), {
        name: "stars",
        class: "mm-rating-stars__empty",
        style: Q(l.value),
        height: 28,
        width: 120
      }, null, 8, ["style"])
    ]));
  }
}), wl = /* @__PURE__ */ T(Sl, [["__scopeId", "data-v-8809fd11"]]), Ls = /* @__PURE__ */ I({
  __name: "MMRating",
  props: {
    rating: {},
    reviewsCount: {},
    ordersCount: {},
    photosCount: {},
    photosPreviews: {},
    compact: { type: Boolean, default: !1 },
    stars: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t;
    return (l, s) => l.compact ? (d(), _(vl, j({ key: 0 }, e, {
      onReviewsClick: s[0] || (s[0] = (r) => l.$emit("reviewsClick"))
    }), null, 16)) : l.stars ? (d(), _(wl, ie(j({ key: 1 }, e)), null, 16)) : (d(), _(_l, j({ key: 2 }, e, {
      onPhotosClick: s[1] || (s[1] = (r) => l.$emit("photosClick")),
      onReviewsClick: s[2] || (s[2] = (r) => l.$emit("reviewsClick"))
    }), null, 16));
  }
}), $l = { class: "mm-select" }, Bl = { class: "mm-select__current-option" }, Cl = { class: "mm-select__options" }, Ll = /* @__PURE__ */ I({
  __name: "MMSelect",
  props: {
    modelValue: { type: [String, Number, Boolean] },
    options: {},
    textProps: { default: () => ({
      font: "Body M/Regular"
    }) },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const l = t, s = $(!1), r = e, n = (i) => {
      r("update:modelValue", i), s.value = !1;
    }, a = v(() => l.options.find((i) => i.value === l.modelValue));
    return (i, c) => (d(), _(g(Re), null, {
      default: V(() => [
        R("div", $l, [
          O(g($e), {
            ref: "menuRef",
            modelValue: s.value,
            "onUpdate:modelValue": c[0] || (c[0] = (o) => s.value = o),
            "full-width": ""
          }, {
            content: V(() => [
              R("div", Cl, [
                (d(!0), k(J, null, te(i.options, (o) => (d(), _(g(ee), {
                  key: `option-${o.value}`,
                  design: o.value === i.modelValue ? "PrimaryNeutral" : "SecondaryNeutral",
                  class: D({
                    "mm-select__option--selected": o.value === i.modelValue
                  }),
                  align: "left",
                  onClick: (m) => n(o.value)
                }, {
                  default: V(() => [
                    q(X(o.label), 1)
                  ]),
                  _: 2
                }, 1032, ["design", "class", "onClick"]))), 128))
              ])
            ]),
            default: V(() => [
              R("div", Bl, [
                O(g(z), ie(lt(i.textProps)), {
                  default: V(() => {
                    var o;
                    return [
                      q(X((o = a.value) == null ? void 0 : o.label), 1)
                    ];
                  }),
                  _: 1
                }, 16)
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }));
  }
}), Vs = /* @__PURE__ */ T(Ll, [["__scopeId", "data-v-d2d7691e"]]);
function K(t) {
  return typeof t == "number" ? `${t}px` : t;
}
const Vl = /* @__PURE__ */ I({
  __name: "MMSkeleton",
  props: {
    gap: {}
  },
  setup(t) {
    const e = t, l = v(() => ({
      gap: K(e.gap)
    }));
    return (s, r) => (d(), k("div", {
      class: "mm-skeleton",
      style: Q(l.value)
    }, [
      A(s.$slots, "default", {}, void 0, !0)
    ], 4));
  }
}), Rs = /* @__PURE__ */ T(Vl, [["__scopeId", "data-v-6bd147cb"]]), Rl = /* @__PURE__ */ I({
  __name: "MMSkeletonItem",
  props: {
    offsetTop: {},
    offsetBottom: {},
    offsetLeft: {},
    offsetRight: {},
    width: {},
    minWidth: {},
    height: {},
    radius: {},
    aspectRatio: {},
    type: {}
  },
  setup(t) {
    const { isTabletAndDown: e } = ut(), l = t, s = v(() => {
      const n = {
        width: "100%",
        borderRadius: "12px"
      };
      switch (l.type) {
        case "text":
          n.height = "16px";
          break;
        case "banner":
          n.aspectRatio = e.value ? "9/5" : "3/1";
          break;
        case "image":
          n.aspectRatio = "3/4", n.border = "1px solid var(--border-subtle)";
          break;
        case "button":
          n.height = "40px", n.borderRadius = "8px", n.border = "1px solid var(--border-subtle)";
          break;
        case "round-button":
          n.height = "40px", n.borderRadius = "50%", n.border = "1px solid var(--border-subtle)";
          break;
      }
      return n;
    }), r = v(() => {
      const n = s.value;
      return {
        height: K(l.height) || n.height,
        width: K(l.width) || n.width,
        minWidth: K(l.minWidth) || n.minWidth,
        borderRadius: K(l.radius) || n.borderRadius,
        aspectRatio: K(l.aspectRatio) || n.aspectRatio,
        marginBottom: K(l.offsetBottom) || n.marginBottom,
        marginTop: K(l.offsetTop) || n.marginTop,
        marginLeft: K(l.offsetLeft) || n.marginLeft,
        marginRight: K(l.offsetRight) || n.marginRight
      };
    });
    return (n, a) => (d(), k("div", {
      class: "mm-skeleton__item",
      style: Q(r.value)
    }, [
      A(n.$slots, "default", {}, void 0, !0)
    ], 4));
  }
}), Ms = /* @__PURE__ */ T(Rl, [["__scopeId", "data-v-1a9cf2cb"]]), Ml = /* @__PURE__ */ I({
  __name: "MMSkeletonColumn",
  props: {
    gap: { default: 0 },
    width: { default: "100%" },
    maxWidth: {},
    minWidth: {},
    height: { default: "100%" },
    padding: {}
  },
  setup(t) {
    const e = t, l = v(() => ({
      gap: K(e.gap),
      width: K(e.width),
      height: K(e.height),
      maxWidth: K(e.maxWidth),
      minWidth: K(e.minWidth),
      padding: K(e.padding)
    }));
    return (s, r) => (d(), k("div", {
      class: "mm-skeleton__column",
      style: Q(l.value)
    }, [
      A(s.$slots, "default", {}, void 0, !0)
    ], 4));
  }
}), Ps = /* @__PURE__ */ T(Ml, [["__scopeId", "data-v-d0e536de"]]), Pl = /* @__PURE__ */ I({
  __name: "MMSkeletonRow",
  props: {
    gap: {},
    align: {},
    justify: {},
    offsetBottom: {},
    offsetTop: {},
    clip: { type: Boolean }
  },
  setup(t) {
    const e = t, l = v(() => ({
      gap: K(e.gap),
      marginBottom: K(e.offsetBottom),
      marginTop: K(e.offsetTop),
      alignItems: e.align,
      justifyContent: e.justify,
      overflowX: e.clip ? "clip" : "visible"
    }));
    return (s, r) => (d(), k("div", {
      class: "mm-skeleton__row",
      style: Q(l.value)
    }, [
      A(s.$slots, "default", {}, void 0, !0)
    ], 4));
  }
}), Is = /* @__PURE__ */ T(Pl, [["__scopeId", "data-v-ddace103"]]), Il = { class: "mm-slider-css" }, Dl = {
  key: 0,
  class: "mm-slider-css__controls"
}, Tl = {
  key: 1,
  class: "mm-slider-css__shadow"
}, Ol = /* @__PURE__ */ I({
  __name: "MMSliderCss",
  props: {
    gap: { default: 24 },
    perView: { default: 1 },
    snap: { type: Boolean, default: !1 },
    loop: { type: Boolean, default: !1 },
    autoscroll: { default: 0 },
    controls: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !1 }
  },
  setup(t) {
    $t((w) => ({
      "277b2404": n.value
    }));
    const e = t, l = $(!1), s = v(() => {
      var x;
      if (typeof e.perView == "number") return e.perView;
      const w = ((x = i.value) == null ? void 0 : x.children[0].clientWidth) ?? 0;
      return y.value / w;
    }), r = v(() => e.perView === 1 ? 1 : s.value - 1), n = v(() => {
      const w = y.value, x = e.gap * (s.value - 1), Z = w - x;
      return e.perView === "auto" ? "auto" : `calc(${Z / s.value}px)`;
    }), a = v(() => ({
      gap: `${e.gap}px`
    })), i = ne("containerRef"), { arrivedState: c, x: o, measure: m, isScrolling: u } = It(i, { behavior: "smooth" }), { width: y } = it(i), { isOutside: b } = Te(i), h = $(null), B = $(!1);
    G(y, (w) => {
      w > 0 && B.value === !1 && (_e(() => {
        m(), e.loop && L(U.value / 3);
      }), B.value = !0);
    }), G(u, (w) => {
      if (e.snap && !w) {
        const x = p() + e.gap;
        o.value = Math.round(o.value / x) * x;
      }
    });
    const C = v(() => c.right), P = v(() => c.left);
    function p() {
      var w;
      return l.value ? 0 : ((w = i.value) == null ? void 0 : w.children[0].clientWidth) ?? 0;
    }
    const f = v(() => {
      const w = p() + e.gap;
      return o.value / w;
    }), W = () => {
      if (P.value) return;
      const w = p() + e.gap;
      let x = f.value - r.value;
      f.value - x < 1 && (x = f.value - 1), o.value = x * w;
    }, H = () => {
      if (C.value) return;
      const w = p() + e.gap;
      let x = f.value + r.value;
      x - f.value < 1 && (x = f.value + 1), o.value = x * w;
    };
    function L(w) {
      var Z;
      const x = p() + e.gap;
      (Z = i.value) == null || Z.scrollTo({
        left: w * x,
        behavior: "instant"
      });
    }
    G(() => e.autoscroll, (w) => {
      w > 0 ? _e(() => {
        h.value = setInterval(() => {
          b.value && H();
        }, w);
      }) : h.value && clearInterval(h.value);
    }, { immediate: !0 });
    const U = v(() => {
      var w;
      return ((w = i.value) == null ? void 0 : w.children.length) || 0;
    });
    G(f, (w) => {
      isNaN(w) || e.loop && (w <= 0.01 && L(U.value / 3), w >= U.value - 1.01 && L(U.value / 3 - 1));
    });
    function Y() {
      l.value = !0, E();
    }
    const E = Ve(() => {
      o.value = Math.round(f.value) * (p() + e.gap), l.value = !1;
    }, 100);
    return Le(() => {
      window.addEventListener("resize", Y);
    }), st(() => {
      window.removeEventListener("resize", Y);
    }), (w, x) => (d(), k("div", Il, [
      R("div", {
        class: "mm-slider-css__container",
        style: Q(a.value),
        ref_key: "containerRef",
        ref: i
      }, [
        w.loop ? A(w.$slots, "default", { key: 0 }, void 0, !0) : S("", !0),
        A(w.$slots, "default", {}, void 0, !0),
        w.loop ? A(w.$slots, "default", { key: 1 }, void 0, !0) : S("", !0)
      ], 4),
      w.controls ? (d(), k("div", Dl, [
        O(g(N), {
          name: "chevron",
          class: D(["mm-slider-css__control-prev", { disabled: P.value && !w.loop }]),
          height: 16,
          width: 16,
          angle: 90,
          onClick: W
        }, null, 8, ["class"]),
        O(g(N), {
          name: "chevron",
          class: D(["mm-slider-css__control-next", { disabled: C.value && !w.loop }]),
          height: 16,
          width: 16,
          angle: -90,
          onClick: H
        }, null, 8, ["class"])
      ])) : S("", !0),
      w.shadow ? (d(), k("div", Tl, [
        R("div", {
          class: D(["mm-slider-css__shadow-start", { disabled: P.value }])
        }, null, 2),
        R("div", {
          class: D(["mm-slider-css__shadow-end", { disabled: C.value }])
        }, null, 2)
      ])) : S("", !0)
    ]));
  }
}), Ds = /* @__PURE__ */ T(Ol, [["__scopeId", "data-v-041f8e9c"]]), Wl = { class: "mm-snackbar-item__content" }, xl = { class: "mm-snackbar-item__icon" }, Al = ["src"], Hl = { class: "mm-snackbar-item__text" }, zl = /* @__PURE__ */ I({
  __name: "MMSnackbarItem",
  props: {
    snackbar: {}
  },
  emits: ["close", "mouseenter", "mouseleave"],
  setup(t, { emit: e }) {
    const l = t, s = v(() => l.snackbar.type === "error"), r = v(() => l.snackbar.type === "info"), n = e;
    function a() {
      var i;
      (i = l.snackbar.button) != null && i.onClick && l.snackbar.button.onClick(), n("close");
    }
    return (i, c) => (d(), k("div", {
      class: D(["mm-snackbar-item", `mm-snackbar-item--${i.snackbar.type}`]),
      key: i.snackbar.id,
      onMouseenter: c[1] || (c[1] = (o) => i.$emit("mouseenter")),
      onMouseleave: c[2] || (c[2] = (o) => i.$emit("mouseleave"))
    }, [
      R("div", Wl, [
        R("div", xl, [
          i.snackbar.icon ? (d(), _(g(N), {
            key: 0,
            name: i.snackbar.icon,
            color: "inverse-primary"
          }, null, 8, ["name"])) : i.snackbar.image ? (d(), k("img", {
            key: 1,
            src: i.snackbar.image,
            class: "mm-snackbar-item__image"
          }, null, 8, Al)) : s.value || r.value ? (d(), _(g(N), {
            key: 2,
            name: "error-circle-filled",
            color: "inverse-primary"
          })) : S("", !0)
        ]),
        R("div", Hl, [
          O(g(z), {
            font: "Body L/Semibold",
            class: "mm-snackbar-item__text-message"
          }, {
            default: V(() => [
              q(X(i.snackbar.message), 1)
            ]),
            _: 1
          }),
          i.snackbar.description ? (d(), _(g(z), {
            key: 0,
            font: "Body M/Regular",
            class: "mm-snackbar-item__text-description"
          }, {
            default: V(() => [
              q(X(i.snackbar.description), 1)
            ]),
            _: 1
          })) : S("", !0)
        ]),
        i.snackbar.button ? (d(), _(g(ee), j({
          key: 0,
          onClick: a
        }, i.snackbar.button.props, {
          "aria-label": i.snackbar.button.label
        }), {
          default: V(() => [
            q(X(i.snackbar.button.label), 1)
          ]),
          _: 1
        }, 16, ["aria-label"])) : S("", !0),
        i.snackbar.isTimeless || i.snackbar.closable ? (d(), k("div", {
          key: 1,
          class: "mm-snackbar-item__close",
          onClick: c[0] || (c[0] = (o) => i.$emit("close")),
          "aria-label": "Закрыть"
        }, [
          O(g(N), {
            name: "dismiss-filled",
            color: "inverse-primary"
          })
        ])) : S("", !0)
      ])
    ], 34));
  }
}), tt = /* @__PURE__ */ T(zl, [["__scopeId", "data-v-657fefc4"]]);
class Ul {
  constructor({
    id: e,
    message: l,
    description: s,
    type: r,
    duration: n = 5e3,
    timeless: a = !1,
    icon: i,
    image: c,
    closable: o = !0,
    button: m,
    position: u = "bottom"
  }, y) {
    M(this, "_id");
    M(this, "_message");
    M(this, "_description");
    M(this, "_type");
    M(this, "_timeless");
    M(this, "timer", null);
    M(this, "remainingTime");
    M(this, "startTime");
    M(this, "onDestroyCallback", null);
    M(this, "icon");
    M(this, "image");
    M(this, "closable");
    M(this, "button");
    M(this, "position");
    this._id = e, this._message = l, this._description = s || "", this._type = r, this._timeless = a, this.remainingTime = n, this.startTime = Date.now(), this.onDestroyCallback = y || null, this.icon = i, this.image = c, this.closable = o, this.button = m, this.position = u, this._timeless || this.startTimer();
  }
  startTimer() {
    this.timer = setTimeout(() => this.destroy(), this.remainingTime);
  }
  pause() {
    this._timeless || !this.timer || (clearTimeout(this.timer), this.remainingTime -= Date.now() - this.startTime);
  }
  resume() {
    this._timeless || (this.startTime = Date.now(), this.startTimer());
  }
  destroy() {
    this.onDestroyCallback && this.onDestroyCallback();
  }
  get id() {
    return this._id;
  }
  get message() {
    return this._message;
  }
  get description() {
    return this._description;
  }
  get type() {
    return this._type;
  }
  get isTimeless() {
    return this._timeless;
  }
}
class Yl {
  constructor({ maxSnackbars: e = 3 }) {
    M(this, "items", []);
    M(this, "maxSnackbars");
    this.maxSnackbars = e;
  }
  createSnackbar(e) {
    const l = Ue(), s = new Ul(
      { ...e, id: l },
      () => this.removeSnackbar(l)
    );
    this.items.push(s);
  }
  removeSnackbar(e) {
    this.items = this.items.filter((l) => l.id !== e);
  }
  destroySnackbar(e) {
    const l = this.items.find((s) => s.id === e);
    l && l.destroy();
  }
  pause(e) {
    const l = this.items.find((s) => s.id === e);
    l && l.pause();
  }
  resume(e) {
    const l = this.items.find((s) => s.id === e);
    l && l.resume();
  }
  get getItems() {
    return this.items;
  }
}
const Ie = $(
  new Yl({ maxSnackbars: 2 })
);
function jl() {
  function t(l) {
    var s;
    (s = Ie.value) == null || s.createSnackbar({
      position: "bottom",
      ...l
    });
  }
  function e(l) {
    var s;
    (s = Ie.value) == null || s.destroySnackbar(l);
  }
  return {
    MMSnackbarController: Ie,
    createSnackbar: t,
    removeSnackbar: e
  };
}
const Xl = { class: "mm-snackbar-container top" }, ql = { class: "mm-snackbar-container bottom" }, Gl = /* @__PURE__ */ I({
  __name: "MMSnackbar",
  setup(t) {
    const { MMSnackbarController: e, removeSnackbar: l } = jl(), s = v(() => {
      var i;
      return (i = e == null ? void 0 : e.value) == null ? void 0 : i.maxSnackbars;
    }), r = v(() => {
      var i;
      return (i = e == null ? void 0 : e.value) == null ? void 0 : i.getItems;
    }), n = v(
      () => {
        var i;
        return (i = r.value) == null ? void 0 : i.filter((c) => c.position === "top").slice(0, s.value);
      }
    ), a = v(
      () => {
        var i;
        return (i = r.value) == null ? void 0 : i.filter((c) => c.position === "bottom").slice(0, s.value);
      }
    );
    return (i, c) => (d(), _(ze, { to: "body" }, [
      R("div", Xl, [
        O(we, { name: "mm-snackbar" }, {
          default: V(() => [
            (d(!0), k(J, null, te(n.value, (o) => (d(), _(tt, {
              key: o.id,
              snackbar: o,
              onMouseenter: (m) => {
                var u;
                return (u = g(e)) == null ? void 0 : u.pause(o.id);
              },
              onMouseleave: (m) => {
                var u;
                return (u = g(e)) == null ? void 0 : u.resume(o.id);
              },
              onClose: (m) => g(l)(o.id)
            }, null, 8, ["snackbar", "onMouseenter", "onMouseleave", "onClose"]))), 128))
          ]),
          _: 1
        })
      ]),
      R("div", ql, [
        O(we, { name: "mm-snackbar" }, {
          default: V(() => [
            (d(!0), k(J, null, te(a.value, (o) => (d(), _(tt, {
              key: o.id,
              snackbar: o,
              onMouseenter: (m) => {
                var u;
                return (u = g(e)) == null ? void 0 : u.pause(o.id);
              },
              onMouseleave: (m) => {
                var u;
                return (u = g(e)) == null ? void 0 : u.resume(o.id);
              },
              onClose: (m) => g(l)(o.id)
            }, null, 8, ["snackbar", "onMouseenter", "onMouseleave", "onClose"]))), 128))
          ]),
          _: 1
        })
      ])
    ]));
  }
}), Ts = /* @__PURE__ */ T(Gl, [["__scopeId", "data-v-ed11ab7d"]]), Nl = { class: "mm-tabs" }, Kl = { class: "mm-tabs__buttons" }, Jl = {
  class: "mm-tabs__content",
  ref: "contentRef"
}, Ql = /* @__PURE__ */ I({
  __name: "MMTabs",
  props: {
    tabs: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const l = t, s = e, r = (a) => {
      s("update:modelValue", a);
    };
    function n(a) {
      return a === l.modelValue;
    }
    return (a, i) => (d(), k("div", Nl, [
      R("div", Kl, [
        (d(!0), k(J, null, te(a.tabs, (c) => (d(), _(g(ee), {
          key: c.id,
          design: n(c.id) ? "PrimaryNeutral" : "SecondaryNeutral",
          size: "M40",
          rounded: "",
          onClick: (o) => r(c.id)
        }, {
          default: V(() => [
            q(X(c.title), 1)
          ]),
          _: 2
        }, 1032, ["design", "onClick"]))), 128))
      ]),
      R("div", Jl, [
        A(a.$slots, `content-${a.modelValue}`, {}, void 0, !0)
      ], 512)
    ]));
  }
}), Os = /* @__PURE__ */ T(Ql, [["__scopeId", "data-v-70dc6b0f"]]), Ws = /* @__PURE__ */ I({
  __name: "MMTimer",
  props: {
    expiresAt: {},
    textProps: { default: () => ({
      font: "Body M/Regular",
      color: "primary"
    }) },
    showHours: { type: Boolean, default: !0 },
    showSeconds: { type: Boolean, default: !0 },
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const l = t, s = e, r = $("00"), n = $("00"), a = $("00"), i = $(), c = () => {
      const y = /* @__PURE__ */ new Date(), b = l.expiresAt.getTime() - y.getTime();
      if (b <= 0) {
        clearInterval(i.value), s("update:modelValue", !0), r.value = "00", n.value = "00", a.value = "00";
        return;
      }
      const h = Math.floor(b / (1e3 * 60 * 60)), B = Math.floor(b % (1e3 * 60 * 60) / (1e3 * 60)), C = Math.floor(b % (1e3 * 60) / 1e3);
      r.value = h.toString().padStart(2, "0"), n.value = B.toString().padStart(2, "0"), a.value = C.toString().padStart(2, "0");
    };
    Le(() => {
      o();
    }), Bt(() => {
      m();
    });
    function o() {
      s("update:modelValue", !1), c(), i.value = setInterval(c, 1e3);
    }
    function m() {
      i.value && clearInterval(i.value), s("update:modelValue", !0);
    }
    G(() => l.expiresAt, (y) => {
      y ? o() : m();
    });
    const u = v(() => {
      const y = [];
      return l.showHours && y.push(r.value), y.push(n.value), l.showSeconds && y.push(a.value), y.join(":");
    });
    return (y, b) => (d(), _(g(z), j(y.textProps, { class: "mm-timer" }), {
      default: V(() => [
        q(X(u.value), 1)
      ]),
      _: 1
    }, 16));
  }
}), de = class de {
  constructor() {
    M(this, "popupIds", /* @__PURE__ */ new Set());
    M(this, "isLocked", !1);
    M(this, "unlockTimeout", null);
  }
  static getInstance() {
    return de.instance || (de.instance = new de()), de.instance;
  }
  addPopup(e) {
    this.popupIds.add(e), this.updateScrollLock();
  }
  removePopup(e) {
    this.popupIds.delete(e), this.updateScrollLock();
  }
  updateScrollLock() {
    const e = this.popupIds.size > 0;
    e !== this.isLocked && (this.isLocked = e, e ? this.lockScroll() : this.unlockScroll());
  }
  isScrollLocked() {
    return this.isLocked;
  }
  fixScrollbarBouncing() {
    const e = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${e}px`;
  }
  lockScroll() {
    this.unlockTimeout && clearTimeout(this.unlockTimeout), this.fixScrollbarBouncing(), document.body.style.overflow = "hidden", document.body.classList.add("scroll-locked");
  }
  unlockScroll() {
    this.unlockTimeout && clearTimeout(this.unlockTimeout), this.unlockTimeout = setTimeout(() => {
      document.body.style.overflow = "", document.body.style.paddingRight = "", document.body.classList.remove("scroll-locked");
    }, 200);
  }
};
M(de, "instance");
let Ae = de;
const xs = Ae.getInstance();
class Zl {
  constructor(e) {
    M(this, "isValid", !1);
    M(this, "hasErrors", !1);
    M(this, "errors", []);
    M(this, "fields", {});
    this.fields = e;
  }
  /** Проверяет все поля на валидность, но не показывает в форме ошибки
   *  Можно использовать для управления disabled стейтом кнопки
   *  при этом не раздражая юзера ошибками, пока он вводит данные
   */
  softValidate() {
    this.validateAllFields(), this.isValid = Object.values(this.fields).every((e) => e.isValid), this.isValid && (this.errors = [], this.hasErrors = !1);
  }
  /** Проверяет все поля на валидность и показывает ошибки в форме
   *  Можно использовать при отправке формы или на ивент blur любого поля
   */
  hardValidate() {
    this.validateAllFields(!0), this.isValid = Object.values(this.fields).every((e) => e.isValid), this.errors = this.getErrors(), this.hasErrors = this.errors.length > 0;
  }
  validateField(e) {
    this.fields[e].hardValidate(), this.softValidate(), this.errors = this.getErrors(), this.hasErrors = this.errors.length > 0;
  }
  validateAllFields(e = !1) {
    Object.values(this.fields).forEach((l) => {
      e ? l.hardValidate() : l.softValidate();
    });
  }
  getErrors() {
    return Object.values(this.fields).map((e) => e.error ? {
      name: e.name,
      error: e.error
    } : null).filter(
      (e) => e !== null
    );
  }
  reset() {
    Object.values(this.fields).forEach((e) => {
      e.reset();
    });
  }
}
class Fl {
  constructor({
    name: e,
    value: l,
    rules: s,
    defaultValue: r
  }) {
    M(this, "error");
    M(this, "isValid");
    M(this, "touched");
    M(this, "name");
    M(this, "rules");
    M(this, "_value");
    M(this, "defaultValue");
    this.name = e, this._value = l, this.rules = s, this.error = null, this.isValid = !1, this.touched = !1, this.defaultValue = r || l || "";
  }
  set value(e) {
    e !== this.defaultValue && (this.touched = !0), this._value = e;
  }
  get value() {
    return this._value;
  }
  softValidate() {
    this.touched = !0, this.rules.filter(
      (l) => !l.function(this.value)
    ).length > 0 ? this.isValid = !1 : (this.error = null, this.isValid = !0);
  }
  hardValidate() {
    this.touched = !0;
    const e = this.rules.filter(
      (l) => !l.function(this.value)
    );
    e.length > 0 ? (this.error = e[e.length - 1].message, this.isValid = !1) : (this.error = null, this.isValid = !0);
  }
  reset() {
    this.error = null, this.value = this.defaultValue, this.touched = !1;
  }
}
function As({
  validateOnMount: t = !1
} = {}) {
  const e = $(null);
  function l(a) {
    const i = Object.entries(a).reduce((c, [o, m]) => (c[o] = new Fl({
      name: o,
      value: m.value,
      rules: m.rules,
      defaultValue: m.defaultValue
    }), c), {});
    e.value = new Zl(i);
  }
  function s(a) {
    var i;
    (i = e.value) == null || i.validateField(a);
  }
  function r() {
    var a;
    (a = e.value) == null || a.reset();
  }
  const n = v(() => {
    var a;
    return Object.values(((a = e.value) == null ? void 0 : a.fields) || {}).some(
      (i) => !!i.touched
    );
  });
  return Le(() => {
    var a;
    t && ((a = e.value) == null || a.hardValidate());
  }), { form: e, touched: n, validateField: s, createForm: l, resetForm: r };
}
function Hs(t) {
  return !!t;
}
function zs(t, e) {
  return !(t.length < e);
}
function Us(t, e) {
  return !(t.length > e);
}
function Ys(t, e) {
  return !!e.test(t);
}
function js(t) {
  return t ? !!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t) : !0;
}
function Xs(t) {
  return !!/^\d{11}$/.test(t);
}
ke.extend(Tt);
function qs(t) {
  return t ? ke(t, "DD-MM-YYYY", !0).isValid() : !0;
}
function Gs(t) {
  if (!t)
    return !0;
  const e = ke(t, "DD-MM-YYYY", !0), l = ke();
  return e.isValid() && e.diff(l, "year") >= 18;
}
export {
  dt as EMMButtonAlign,
  se as EMMButtonDesign,
  ae as EMMButtonSize,
  at as EMMIconAnimtaion,
  Wt as EMMIconColor,
  At as EMMIconName,
  nt as EMMTextFontColor,
  rt as EMMTextFontToken,
  is as MMAccordion,
  as as MMBadge,
  ee as MMButton,
  ns as MMCard,
  rs as MMCheckbox,
  us as MMCodeField,
  ds as MMContainer,
  Re as MMField,
  Zl as MMFormClass,
  Fl as MMFormFieldClass,
  N as MMIcon,
  Ye as MMImage,
  cs as MMImageSlider,
  pe as MMInput,
  bs as MMInputCounter,
  hs as MMInputDate,
  ps as MMInputEmail,
  gs as MMInputMenu,
  vs as MMInputPhone,
  ys as MMLink,
  $e as MMMenu,
  Xo as MMNotification,
  _s as MMNotificationsContainer,
  ks as MMPopupControllerTarget,
  Ss as MMPopupDefault,
  ws as MMPopupFullScreen,
  $s as MMPopupFullWidth,
  Bs as MMPopupPromo,
  Cs as MMRange,
  Ls as MMRating,
  vl as MMRatingCompact,
  wl as MMRatingStars,
  Vs as MMSelect,
  Rs as MMSkeleton,
  Ps as MMSkeletonColumn,
  Ms as MMSkeletonItem,
  Is as MMSkeletonRow,
  ct as MMSlider,
  Ds as MMSliderCss,
  Ts as MMSnackbar,
  Os as MMTabs,
  z as MMText,
  Ws as MMTimer,
  Gs as ValidationRuleBirthDate,
  qs as ValidationRuleDate,
  js as ValidationRuleEmail,
  Us as ValidationRuleMaxLength,
  zs as ValidationRuleMinLength,
  Ys as ValidationRulePattern,
  Xs as ValidationRulePhone,
  Hs as ValidationRuleRequired,
  fs as formatDate,
  ft as formatNumberWithSpaces,
  ms as formatPhone,
  et as getPluralForm,
  pt as mergeDeep,
  xs as overflowController,
  Ce as pluralize,
  Do as stripMask,
  As as useMMForm,
  mt as useMMNotification,
  jl as useMMSnackbar,
  ut as useMedia,
  Fo as usePopups
};
